/* WSH FYS Results — Amendment 2 mockup-parity hydrator.
 * Reads window.__wshFys.getState() (quiz answers) + ?view=fys-data (catalog +
 * curated bundles + sampler kits + scoring config) + ?view=fys-owned (per-
 * customer owned handles). Runs window.fysScore(...) to get match/next/wildcard
 * /guitar_layer + strip. Hydrates the semantic scaffold in wsh-fys-results.liquid.
 *
 * All copy + colours + sizes match reference/fys-mockup/Results.dc.html +
 * ResultsMobile.dc.html verbatim (see wsh-fys-results.css).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-wsh-fys-results]');
  if (!root) return;

  // Brief §3.B.6: waveform colours resolve from FYS tokens, not JS literals.
  // Readers lazily so vars resolve after the stylesheet applies.
  function _fysOnDarkHex() {
    var v = getComputedStyle(document.body).getPropertyValue('--fys-on-dark').trim();
    return v || '#F0E8D5';
  }
  function _fysOnDarkRgba(alpha) {
    var hex = _fysOnDarkHex().replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }

  var GENRE_NAME = {
    'country': 'Country',
    'rock': 'Rock',
    'jazz-blues': 'Jazz & Blues',
    'indie': 'Indie',
    'cinematic': 'Cinematic',
    'ambient': 'Cinematic',
    'pop': 'Pop',
    'country-drum-loops': 'Country',
    'rock-drum-loops': 'Rock',
    'jazz-drum-loops': 'Jazz & Blues',
    'indie-drum-loops': 'Indie',
    'ambient-drum-loops': 'Cinematic',
    'pop-drum-sample-packs': 'Pop',
  };
  var GENRE_URL = {
    'Country': '/collections/country',
    'Rock': '/collections/rock',
    'Jazz & Blues': '/collections/jazz-blues',
    'Indie': '/collections/indie',
    'Cinematic': '/collections/cinematic',
    'Pop': '/collections/pop',
  };
  // P2 §D4: USE_LABEL keys match the quiz's data-use values exactly. The
  // older {producer,songwriter,filmscore,mixer,other} map never matched the
  // quiz output and silently fell through to titleCase.
  var USE_LABEL = {
    songs: 'Songwriting',
    tracks: 'Producing',
    picture: 'Music for picture',
    exploring: 'Exploring',
  };
  var FMT_LABEL = { full_band: 'Full band', drums: 'Drums only', both: 'Both', full: 'Full band' };

  // P2 §D2: shared describe-it maps. Labels drive the picked-panel heading
  // ("Driving · Vintage and raw"); the bar-value maps mirror the quiz's own
  // profile-panel numbers for the SAME answers — one source of truth, so the
  // described user's bars on results match what they already saw.
  var ENERGY_LABEL = { laid: 'Laid back', steady: 'Steady groove', driving: 'Driving' };
  var FEEL_LABEL   = { vintage: 'Vintage and raw', between: 'Somewhere between', modern: 'Modern and polished' };
  var FB_ENERGY_PCT = { laid: 28, steady: 50, driving: 76 };
  var FB_FEEL_PCT   = { vintage: 20, between: 50, modern: 80 };
  function titleCase(s) {
    return String(s || '').replace(/(^|[_\-\s])(\w)/g, function (_, sep, c) { return (sep === '_' || sep === '-' ? ' ' : sep) + c.toUpperCase(); });
  }
  var DAW_INITIAL = { 'Cubase': 'C', 'Logic Pro': 'L', 'Ableton Live': 'A', 'Pro Tools': 'P', 'Studio One': 'S', 'Reaper': 'R', 'FL Studio': 'F', 'GarageBand': 'G' };

  var data = null;
  var owned = { signed_in: false, owned: [], owned_titles: {} };
  var ui = { nIdx: 0, wIdx: 0, gIdx: 0, tab: 'match', playing: null };
  var scoreResult = null;
  var bundleToken = null;

  function dawIconUrl(dawLabel) {
    var m = window.WSH_DAW_MAP;
    if (!m || !m.byLabel) return '';
    var it = m.byLabel[String(dawLabel || '').toLowerCase()];
    return it && it.icon_url ? it.icon_url : '';
  }

  function bundleDiscount(childCount) {
    if (childCount >= 4) return '20%';
    if (childCount === 3) return '15%';
    return '10%';
  }

  // P2 §D6: every price shows the visitor's active-market currency symbol +
  // locale decimals, matching how the soundbar + PDPs render. Prefer
  // Intl.NumberFormat with Shopify.currency.active (the active market's
  // code) — the amount is already in presentment cents from the fys-data
  // endpoint (Liquid's p.price). The hard-coded "$" fallback is retired.
  function formatMoney(cents) {
    var n = Number(cents) || 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
                || root.getAttribute('data-shop-currency')
                || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n / 100);
    } catch (e) {
      // Last resort: emit the amount without a symbol so no misleading $ appears.
      return (n / 100).toFixed(2);
    }
  }

  function filterOwnedFromCatalog(catalog, ownedList) {
    if (!ownedList || !ownedList.length) return catalog;
    var oset = {};
    for (var i = 0; i < ownedList.length; i++) oset[ownedList[i]] = true;
    return catalog.filter(function (lib) { return !oset[lib.handle]; });
  }

  function q(sel, scope) { return (scope || root).querySelector(sel); }
  function qa(sel, scope) { return (scope || root).querySelectorAll(sel); }
  function ce(tag, cls, txt) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (txt != null) el.textContent = txt;
    return el;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderSignRow() {
    var guest = q('[data-wsh-signrow-guest]');
    var ownedRow = q('[data-wsh-signrow-owned]');
    if (!guest || !ownedRow) return;
    if (!owned.signed_in) {
      guest.hidden = false;
      ownedRow.hidden = true;
      return;
    }
    var elig = data && data.libraries ? data.libraries : {};
    var chips = q('[data-wsh-owned-chips]');
    var prefix = q('[data-wsh-owned-prefix]');
    if (!chips || !prefix) return;
    chips.innerHTML = '';
    var visible = [];
    for (var i = 0; i < owned.owned.length; i++) {
      var h = owned.owned[i];
      if (elig[h]) {
        var title = owned.owned_titles[h] || elig[h].title || h;
        visible.push({ handle: h, title: title });
      }
    }
    if (!visible.length) {
      /* SI §C5 (2026-10-03): a signed-in visitor who owns none of the
         libraries never sees the guest line. The signed-in row shows
         with the alternate prefix and no chips. */
      prefix.textContent = 'Signed in. Every pick here is new to you.';
      guest.hidden = true;
      ownedRow.hidden = false;
      return;
    }
    prefix.textContent = 'Signed in. Left out the ' + visible.length + ' you own:';
    /* Cart slice (Phil, 8 Oct): a long list would fill the first screen on a
       phone. Four names, then a "+N more" chip that opens the rest in place.
       Never hide a single name: five or fewer are all shown. */
    var shownCount = (ownedListOpen || visible.length <= OWNED_SHOWN + 1) ? visible.length : OWNED_SHOWN;
    for (var j = 0; j < shownCount; j++) {
      chips.appendChild(ce('span', 'wsh-fys-owned-chip', visible[j].title));
    }
    if (shownCount < visible.length) {
      var more = ce('button', 'wsh-fys-owned-chip wsh-fys-owned-chip--more', '+' + (visible.length - shownCount) + ' more');
      more.type = 'button';
      more.setAttribute('data-wsh-owned-more', '');
      more.setAttribute('aria-label', '+' + (visible.length - shownCount) + ' more: show all ' + visible.length + ' libraries you own');
      more.addEventListener('click', function () {
        ownedListOpen = true;
        renderSignRow();
        var c = q('[data-wsh-owned-chips] .wsh-fys-owned-chip:nth-child(' + (OWNED_SHOWN + 1) + ')');
        if (c) { c.setAttribute('tabindex', '-1'); try { c.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
      });
      chips.appendChild(more);
    }
    guest.hidden = true;
    ownedRow.hidden = false;
  }
  var OWNED_SHOWN = 4;
  var ownedListOpen = false;

  function renderHeadChips(answers) {
    var chipsEl = q('[data-wsh-answer-chips]');
    if (!chipsEl) return;
    chipsEl.innerHTML = '';
    // P2 §A4: chip order follows the new question order —
    //   genre → format → picked/described → creating → DAW.
    var chips = [];
    if (answers.genre) chips.push(GENRE_NAME[answers.genre] || answers.genre);
    if (answers.format) chips.push(FMT_LABEL[answers.format] || titleCase(answers.format));
    if (answers.pick && answers.pick.tile) chips.push('Picked Sound ' + answers.pick.tile);
    else if (answers.fallback) chips.push('Described');
    if (answers.use) chips.push(USE_LABEL[answers.use] || titleCase(answers.use));
    // P2 §D3: Other reads "Other DAW" in the header-chips row.
    if (answers.daw) chips.push(answers.daw === 'Other' ? 'Other DAW' : answers.daw);
    chips.forEach(function (t) { chipsEl.appendChild(ce('span', 'wsh-fys-chip', t)); });
  }

  function renderBarStack(wrap, rows) {
    rows.forEach(function (r) {
      var bar = ce('div', 'wsh-fys-bar');
      bar.appendChild(ce('span', 'wsh-fys-bar__label', r.l));
      var row = ce('div', 'wsh-fys-bar__row');
      row.appendChild(ce('span', 'wsh-fys-bar__end', r.left));
      var track = ce('span', 'wsh-fys-bar__track');
      var pct = Math.max(0, Math.min(100, Number(r.p) || 0));
      var fill = ce('span', 'wsh-fys-bar__fill');
      fill.style.width = pct + '%';
      var thumb = ce('span', 'wsh-fys-bar__thumb');
      thumb.style.left = pct + '%';
      track.appendChild(fill);
      track.appendChild(thumb);
      row.appendChild(track);
      row.appendChild(ce('span', 'wsh-fys-bar__end wsh-fys-bar__end--right', r.right));
      bar.appendChild(row);
      wrap.appendChild(bar);
    });
  }

  function renderPicked(answers, anchorLib) {
    var panel = q('[data-wsh-picked-panel]');
    if (!panel) return;
    // Section 1 symptom (d) fix (Phil 2026-10-01 pm): described path has NO
    // picked kit — the panel shows "YOU DESCRIBED IT AS" + their two answers
    // (energy/feel) + anchor sliders + no play button.
    var described = !!(answers.fallback && (answers.fallback.energy || answers.fallback.feel) && !(answers.pick && answers.pick.tile));
    var eyebrowEl = q('.wsh-fys-picked__eyebrow', panel);
    var playEl = q('[data-wsh-picked-play]', panel);
    var hintEl = q('[data-wsh-picked-hint]');
    var titleEl = q('[data-wsh-picked-title]');
    var subEl = q('[data-wsh-picked-sub]');
    var barsWrap = q('[data-wsh-picked-bars]');

    if (described) {
      panel.hidden = false;
      panel.classList.add('is-described');
      if (eyebrowEl) eyebrowEl.textContent = 'YOU DESCRIBED IT AS';
      // P2 §D2: labels use the quiz's own keys (laid/steady/driving + vintage
      // /between/modern) and surface the full-length copy ("Laid back",
      // "Vintage and raw", "Somewhere between", "Modern and polished").
      var e = (answers.fallback.energy || '').toLowerCase();
      var f = (answers.fallback.feel || '').toLowerCase();
      if (titleEl) titleEl.textContent = (ENERGY_LABEL[e] || e || '—') + ' · ' + (FEEL_LABEL[f] || f || '—');
      if (subEl) subEl.textContent = 'The anchor these three cards sit against.';
      if (hintEl) hintEl.textContent = '';
      if (playEl) playEl.hidden = true;
    } else if (anchorLib) {
      panel.hidden = false;
      panel.classList.remove('is-described');
      if (eyebrowEl) eyebrowEl.textContent = 'THE SOUND YOU PICKED BY EAR WAS';
      if (titleEl) titleEl.textContent = anchorLib.title;
      // Item 18 (Rev 2 carryover): picked panel subtitle ends with "… And your match."
      var pickedSubRaw = anchorLib.soundbar_subtitle || anchorLib.highlights_sounds_like || '';
      var pickedSub = String(pickedSubRaw).trim().replace(/[.\s]+$/, '');
      if (subEl) subEl.textContent = pickedSub ? (pickedSub + '. And your match.') : 'And your match.';
      if (hintEl) {
        if (answers.pick && answers.pick.tile) hintEl.textContent = 'Sound ' + answers.pick.tile + ' · the kit you chose';
        else hintEl.textContent = '';
      }
      if (playEl) playEl.hidden = false;
    } else {
      panel.hidden = true;
      return;
    }

    if (barsWrap) {
      barsWrap.innerHTML = '';
      var vals = described
        ? describedAnchorValues(answers.fallback)
        : [Number(anchorLib.mood_energy), Number(anchorLib.mood_tone), Number(anchorLib.mood_era), Number(anchorLib.mood_production)];
      renderBarStack(barsWrap, [
        { l: 'ENERGY', left: 'Mellow', right: 'Driving', p: vals[0] },
        { l: 'TONE', left: 'Warm', right: 'Bright', p: vals[1] },
        { l: 'ERA', left: 'Vintage', right: 'Modern', p: vals[2] },
        { l: 'PRODUCTION', left: 'Raw', right: 'Polished', p: vals[3] },
      ]);
    }
  }

  // P2 §D2: bar values mirror the quiz's own profile-panel numbers for the
  // same described answers (one shared map, the quiz's values). Shape:
  // [energy, tone, era, production] percentages — tone is constant 40 to
  // mirror the quiz's fixed tone slot in the describe-it fallback.
  function describedAnchorValues(fb) {
    var e = ((fb && fb.energy) || '').toLowerCase();
    var f = ((fb && fb.feel) || '').toLowerCase();
    var energyPct = (FB_ENERGY_PCT[e] != null) ? FB_ENERGY_PCT[e] : 50;
    var feelPct   = (FB_FEEL_PCT[f]   != null) ? FB_FEEL_PCT[f]   : 50;
    return [energyPct, 40, feelPct, feelPct];
  }

  var ROLE_META = {
    match: { role: 'RIGHT IN YOUR LANE', roleName: 'The match', roleSub: 'Your pick, chosen by ear' },
    next: { role: 'ONE STEP OVER', roleName: 'The next step', roleSub: 'Same genre, a step from your pick' },
    wildcard: { role: 'NEW TERRITORY', roleName: 'The wildcard', roleSub: 'A new genre with the same feel' },
  };

  function bandWordsFor(lib) {
    var bands = (data && data.scoring && data.scoring.bands) || null;
    if (bands && typeof window.__fysScoreInternal !== 'undefined' && typeof window.__fysScoreInternal._bandWords === 'function') {
      try { return window.__fysScoreInternal._bandWords(lib, bands); } catch (e) { /* noop */ }
    }
    return 'steady, warm and vintage';
  }

  // Item 6 / Item 21: parse artist names out of highlights_sounds_like.
  // Three patterns in the catalog:
  //   A: "{Library Title} is a celebration of artists and groups like A, B, C, ..., and so many more"
  //   B: "A, B, C, and others."
  //   C: Rev 3 add — "...in the style of A, B, C..." (Crossroads Blues +Drums, Electrifried Blues +Drums).
  // Take the substring after "like " / "in the style of " if present, else the whole thing.
  // Split on commas, trim, drop items matching bail tails, return first 2.
  var TAIL_BAIL = /^(and\s+)?(so\s+many\s+more|many\s+more|others|so\s+on)[.\s]*$/i;
  function parseArtists(soundsLike) {
    if (!soundsLike) return null;
    var s = String(soundsLike).trim();
    // Pattern C: "in the style of ..." — Rev 3 add for Crossroads/Electrifried Blues.
    var m = s.match(/in\s+the\s+style\s+of\s+(.+)$/i) || s.match(/like\s+(.+)$/i);
    var tail = m ? m[1] : s;
    // Remove trailing period(s), ellipses, BOM/zero-width
    tail = tail.replace(/[\u200B\uFEFF]+/g, '').replace(/[.\s]+$/, '');
    var parts = tail.split(/,\s*/);
    var clean = [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (!p) continue;
      if (TAIL_BAIL.test(p)) continue;
      // Strip leading "and " if present at the boundary
      p = p.replace(/^and\s+/i, '');
      if (TAIL_BAIL.test(p)) continue;
      clean.push(p);
      if (clean.length === 2) break;
    }
    if (clean.length < 2) return null;
    return clean;
  }

  // Item 21 (brief Rev 3): Mariachi's highlights_sounds_like is a celebration
  // of styles ("Son Jaliscience, Ranchera, Huapango, Jarabe …"), not artist
  // names. The structural parser can't distinguish styles from artists at the
  // comma-list level, so hide the "In the spirit of" line by HANDLE. Add other
  // handles here as they surface.
  var HIDE_SPIRIT_HANDLES = { 'mariachi': true };

  function inTheSpiritLine(lib) {
    // Item 21: hide the line entirely for libraries whose sounds_like holds
    // music styles rather than artist names (handle-exclusion list above).
    if (lib && HIDE_SPIRIT_HANDLES[lib.handle]) return '';
    var artists = parseArtists(lib && lib.highlights_sounds_like);
    if (!artists) return '';
    return 'In the spirit of ' + artists[0] + ' and ' + artists[1] + '.';
  }

  function whyForRole(role, lib, matchLib) {
    if (role === 'match') {
      return {
        p1: 'You picked it by ear, and it sits right on your answers: ' + bandWordsFor(lib) + '.',
        p2: inTheSpiritLine(lib),
      };
    }
    if (role === 'next') {
      return {
        p1: 'One step over from ' + (matchLib ? matchLib.title : 'your match') + ': ' + bandWordsFor(lib) + '.',
        p2: inTheSpiritLine(lib),
      };
    }
    var libGenre = GENRE_NAME[lib.genre_collection_handle] || '';
    return {
      p1: 'The same ' + bandWordsFor(matchLib || lib) + ' feel as ' + (matchLib ? matchLib.title : 'your match') + ', heard through ' + libGenre + '.',
      p2: inTheSpiritLine(lib),
    };
  }

  // Item 8: bundle names always end in " Bundle".
  function bundleFullTitle(title) {
    var t = String(title || '').trim();
    if (!t) return '';
    if (/\bBundle\b\s*$/i.test(t)) return t;
    return t + ' Bundle';
  }

  // Item 10: image fallback chain.
  function imageFor(lib) {
    if (!lib) return '';
    return lib.tier_1_card_image_url || lib.featured_image_url || '';
  }

  // P2 §D3: WAV tag conditions — chosen DAW is Other or FL Studio, OR the
  // library is in fys_config.wav_only. No "version on the way" pill, no
  // helper line, no icon square — plain opens-in pill style.
  function isWavOnlyHandle(h) {
    if (!data || !data.fys_config || !data.fys_config.wav_only) return false;
    return data.fys_config.wav_only.indexOf(h) !== -1;
  }
  function dawIsWavOnlyDaw(daw) {
    return daw === 'Other' || daw === 'FL Studio';
  }
  function shouldShowWavTag(lib, daw) {
    return dawIsWavOnlyDaw(daw) || (lib && isWavOnlyHandle(lib.handle));
  }

  function dawPillHtml(lib, daw, includeSoonHint) {
    if (!daw) return '';
    if (shouldShowWavTag(lib, daw)) {
      return '<span class="wsh-fys-daw-pill wsh-fys-daw-pill--wav">✓ WAV, works in any DAW</span>';
    }
    var ok = false;
    if (Array.isArray(lib.daw_sessions)) {
      for (var i = 0; i < lib.daw_sessions.length; i++) {
        if (lib.daw_sessions[i].label === daw && lib.daw_sessions[i].has_session) { ok = true; break; }
      }
    }
    var icon = dawIconUrl(daw);
    var iconInner = icon ? '<img src="' + icon + '" alt="" width="16" height="16">' : (DAW_INITIAL[daw] || daw.charAt(0));
    if (ok) {
      return '<span class="wsh-fys-daw-pill wsh-fys-daw-pill--ok">' +
        '<span class="wsh-fys-daw-pill__icon">' + iconInner + '</span>' +
        '✓ Opens in ' + escapeHtml(daw) + '</span>';
    }
    var soon = '<span class="wsh-fys-daw-pill wsh-fys-daw-pill--soon">' +
      '<span class="wsh-fys-daw-pill__icon">' + iconInner + '</span>' +
      escapeHtml(daw.toUpperCase()) + ' VERSION ON THE WAY</span>';
    if (!includeSoonHint) return soon;
    return '<div class="wsh-fys-daw-soon-wrap">' + soon +
      '<span class="wsh-fys-daw-soon-hint">Comes as WAV today, ready to drag and drop into ' + escapeHtml(daw) + '.</span>' +
      '</div>';
  }

  function typeLineFor(lib) {
    var fmt = lib.type === 'Drum Product' ? 'Drums' : 'Full band';
    var genre = GENRE_NAME[lib.genre_collection_handle] || '';
    return fmt + ' library · ' + genre;
  }

  function bundlePanelHtml(lib) {
    if (!lib.featured_bundle_handle) return '';
    var save = bundleDiscount(Number(lib.featured_bundle_children_count) || 2);
    var t1 = '', t2 = '';
    if (Array.isArray(lib.featured_bundle_children_handles) && lib.featured_bundle_children_handles.length) {
      var kid1 = data.libraries[lib.featured_bundle_children_handles[0]];
      var kid2 = data.libraries[lib.featured_bundle_children_handles[1]];
      if (kid1) t1 = imageFor(kid1);
      if (kid2) t2 = imageFor(kid2);
    }
    var cb = data.curated_bundles[lib.featured_bundle_handle];
    var url = cb ? cb.url : '#';
    var rawTitle = lib.featured_bundle_title || (cb ? cb.title : '');
    var title = escapeHtml(bundleFullTitle(rawTitle));
    // Phil review item 6 / brief §3.C.11: ONE square 38px thumbnail — the
    // bundle's own image. The featured_bundle_image_url points at the
    // bundle's cover (set via the metaobject); fall back to the first child
    // image if that's missing. (The old two-thumb stacked pair was a
    // pre-brief layout.)
    var bundleImg = (lib.featured_bundle_image_url && lib.featured_bundle_image_url.length) ? lib.featured_bundle_image_url : t1;
    // P2 §D7: panels open in a new tab + pause the results sound.
    return '<a class="wsh-fys-panel" href="' + url + '" target="_blank" rel="noopener">' +
      '<span class="wsh-fys-panel__thumb"' + (bundleImg ? ' style="background-image:url(' + bundleImg + ')"' : '') + '></span>' +
      '<span class="wsh-fys-panel__body">' +
        '<span class="wsh-fys-panel__eyebrow">ALSO IN THE BUNDLE</span>' +
        '<span class="wsh-fys-panel__title">' + title + '</span>' +
      '</span>' +
      '<span class="wsh-fys-panel__save">SAVE ' + save + '</span>' +
      '<span class="wsh-fys-panel__arrow">→</span>' +
      '</a>';
  }

  function drumsPanelHtml(lib) {
    if (!lib.paired_edition_handle) return '';
    var paired = data.libraries[lib.paired_edition_handle];
    if (!paired) return '';
    if (paired.type !== 'Drum Product') return '';
    var thumb = imageFor(paired);
    // P2 §D7: panels open in a new tab + pause the results sound.
    return '<a class="wsh-fys-panel" href="' + paired.url + '" target="_blank" rel="noopener">' +
      '<span class="wsh-fys-panel__thumb"' + (thumb ? ' style="background-image:url(' + thumb + ')"' : '') + '></span>' +
      '<span class="wsh-fys-panel__body">' +
        '<span class="wsh-fys-panel__eyebrow">DRUMS ON THEIR OWN</span>' +
        '<span class="wsh-fys-panel__title">' + escapeHtml(paired.title) + '</span>' +
      '</span>' +
      '<span class="wsh-fys-panel__price">' + formatMoney(paired.price_cents) + '</span>' +
      '<span class="wsh-fys-panel__arrow">→</span>' +
      '</a>';
  }

  function isOwned(handle) {
    return !!(owned && owned.owned && owned.owned.indexOf(handle) >= 0);
  }

  function renderCard(role, lib, matchLib) {
    var card = q('[data-wsh-card="' + role + '"]');
    if (!card || !lib) return;
    var meta = ROLE_META[role];
    q('[data-wsh-card-role]', card).textContent = meta.role;
    q('[data-wsh-card-role-name]', card).textContent = meta.roleName;
    q('[data-wsh-card-role-sub]', card).textContent = meta.roleSub;
    var img = q('[data-wsh-card-image]', card);
    var imgUrl = imageFor(lib);
    img.style.backgroundImage = imgUrl ? 'url(' + imgUrl + ')' : '';
    if (lib.featured_image_focal) img.style.setProperty('--wsh-card-focal', lib.featured_image_focal);
    q('[data-wsh-card-title]', card).textContent = lib.title;
    q('[data-wsh-card-type]', card).textContent = typeLineFor(lib);
    var why = whyForRole(role, lib, matchLib);
    q('[data-wsh-card-why]', card).textContent = why.p1;
    q('[data-wsh-card-why2]', card).textContent = why.p2;
    var barsEl = q('[data-wsh-card-bars]', card);
    barsEl.innerHTML = '';
    renderBarStack(barsEl, [
      { l: 'ENERGY', left: 'Mellow', right: 'Driving', p: Number(lib.mood_energy) },
      { l: 'TONE', left: 'Warm', right: 'Bright', p: Number(lib.mood_tone) },
      { l: 'ERA', left: 'Vintage', right: 'Modern', p: Number(lib.mood_era) },
      { l: 'PRODUCTION', left: 'Raw', right: 'Polished', p: Number(lib.mood_production) },
    ]);
    var daw = (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState().daw) || '';
    q('[data-wsh-card-daw]', card).innerHTML = dawPillHtml(lib, daw, true);
    // Section 2 (Phil 2026-10-01 pm): match card for an owned library swaps
    // price → IN YOUR COLLECTION tag + a copy line below; CTA → FIND ANOTHER
    // SOUND; bundle + drums panels hide when those are owned too.
    var priceEl = q('[data-wsh-card-price]', card);
    var ctaEl = q('[data-wsh-card-cta]', card);
    var ownedThisMatch = (role === 'match') && isOwned(lib.handle);
    card.classList.toggle('is-owned', ownedThisMatch);
    if (ownedThisMatch) {
      priceEl.innerHTML = '<span class="wsh-fys-collection-tag">IN YOUR COLLECTION</span>' +
                          '<span class="wsh-fys-collection-note">Great ear. You picked one you already own.</span>';
      ctaEl.textContent = 'FIND ANOTHER SOUND';
      ctaEl.setAttribute('href', '#');
      ctaEl.setAttribute('data-wsh-find-another', '');
      // In-page action — stays in-tab.
      ctaEl.removeAttribute('target');
      ctaEl.removeAttribute('rel');
    } else {
      priceEl.textContent = formatMoney(lib.price_cents);
      ctaEl.textContent = 'EXPLORE THE LIBRARY';
      ctaEl.setAttribute('href', lib.url);
      ctaEl.removeAttribute('data-wsh-find-another');
      // P2 §D7: product links open in a new tab + pause the results sound.
      ctaEl.setAttribute('target', '_blank');
      ctaEl.setAttribute('rel', 'noopener');
    }
    // Panels: hide bundle if bundle itself is owned; hide drums if drums are
    // owned. Fallback to full-visible when a lookup fails.
    var bundleHtml = '';
    if (lib.featured_bundle_handle && !isOwned(lib.featured_bundle_handle)) bundleHtml = bundlePanelHtml(lib);
    var drumsHtml = '';
    if (lib.paired_edition_handle && !isOwned(lib.paired_edition_handle)) drumsHtml = drumsPanelHtml(lib);
    q('[data-wsh-card-panels]', card).innerHTML = bundleHtml + drumsHtml;
    var cyc = q('[data-wsh-card-cycle]', card);
    cyc.innerHTML = '';
    if (role === 'match') {
      cyc.appendChild(ce('span', 'wsh-fys-card__match-label', 'YOUR PICK · CHOSEN BY EAR'));
    } else {
      // Rev 3 v3 board: button carries a ↻ cycle-SVG + "SHOW ME ANOTHER" (11px tracked).
      var btn = ce('button', 'wsh-fys-card__show-another');
      btn.type = 'button';
      btn.setAttribute('data-wsh-show-another', role);
      btn.innerHTML = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 4v5h-5"/></svg><span>SHOW ME ANOTHER</span>';
      cyc.appendChild(btn);
      var swatchRow = ce('div', 'wsh-fys-card__swatch-row');
      var opts = role === 'next' ? scoreResult.next.options : scoreResult.wildcard.options;
      var curIdx = role === 'next' ? ui.nIdx : ui.wIdx;
      for (var i = 0; i < Math.min(opts.length, 3); i++) {
        var optHandle = opts[i].handle;
        var optLib = data.libraries[optHandle];
        var s = ce('button', 'wsh-fys-card__swatch' + (i === curIdx ? ' wsh-fys-card__swatch--active' : ''));
        s.type = 'button';
        s.setAttribute('aria-label', optLib ? ('Show ' + optLib.title) : ('Show option ' + (i + 1)));
        s.setAttribute('data-wsh-swatch', role);
        s.setAttribute('data-wsh-swatch-idx', String(i));
        if (optLib) {
          var t = optLib.tier_1_card_image_url || optLib.featured_image_url;
          if (t) s.style.backgroundImage = 'url(' + t + ')';
        }
        swatchRow.appendChild(s);
      }
      swatchRow.appendChild(ce('span', 'wsh-fys-card__idx-label', (curIdx + 1) + ' of ' + Math.min(opts.length, 3)));
      cyc.appendChild(swatchRow);
    }
  }

  function renderGuitarCard() {
    var wrap = q('[data-wsh-guitar]');
    if (!wrap) return;
    var opts = (scoreResult && scoreResult.guitar_layer && scoreResult.guitar_layer.options) || [];
    if (!opts.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var idx = ui.gIdx % opts.length;
    var lib = data.libraries[opts[idx].handle];
    if (!lib) { wrap.hidden = true; return; }
    var imgEl = q('[data-wsh-guitar-image]');
    var t = lib.tier_1_card_image_url || lib.featured_image_url;
    imgEl.style.backgroundImage = t ? 'url(' + t + ')' : '';
    imgEl.textContent = '';
    q('[data-wsh-guitar-title]').textContent = lib.title;
    // Item 7: parse highlights_instruments (single_line_text_field, e.g.
    // "Electric, Baritone, Slide, and more.") — split by comma, drop
    // "and more"/"and others" tails + trailing period/BOM, take first 3,
    // lowercase, join with commas + "and". Source: highlights_instruments
    // per Phil directive (all sampled Country guitar libs carry the field).
    // Fallback: highlights_instruments unavailable → skip the ": {instruments}"
    // clause and drop the "known for" fragment entirely.
    var known = '';
    var instrRaw = lib.highlights_instruments;
    var instrArr = null;
    if (Array.isArray(instrRaw)) instrArr = instrRaw.slice();
    else if (typeof instrRaw === 'string') instrArr = instrRaw.split(/,\s*/);
    if (instrArr && instrArr.length) {
      var cleaned = [];
      for (var i = 0; i < instrArr.length; i++) {
        var it = String(instrArr[i]).trim().replace(/[\u200B\uFEFF]+/g, '').replace(/[.\s]+$/, '');
        if (!it) continue;
        if (/^(and\s+)?(more|others|so\s+on|and\s+more)$/i.test(it)) continue;
        it = it.replace(/^and\s+/i, '');
        if (/\s+guitars?$/i.test(it)) it = it.replace(/\s+guitars?$/i, '');
        cleaned.push(it.toLowerCase());
        if (cleaned.length === 3) break;
      }
      if (cleaned.length >= 2) {
        if (cleaned.length === 3) known = cleaned[0] + ', ' + cleaned[1] + ' and ' + cleaned[2];
        else known = cleaned[0] + ' and ' + cleaned[1];
      }
    }
    var matchLib = data.libraries[scoreResult.match.handle];
    var matchTitle = matchLib ? matchLib.title : 'your match';
    var feel = bandWordsFor(matchLib || lib);
    var whyEl = q('[data-wsh-guitar-why]');
    if (known) {
      whyEl.textContent = 'Session guitar parts to layer over ' + matchTitle + ': ' + known + ', with the same ' + feel + ' feel.';
    } else {
      whyEl.textContent = 'Session guitar parts to layer over ' + matchTitle + ', with the same ' + feel + ' feel.';
    }
    var daw = (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState().daw) || '';
    q('[data-wsh-guitar-daw]').innerHTML = dawPillHtml(lib, daw, false);
    var price = formatMoney(lib.price_cents);
    q('[data-wsh-guitar-price]').textContent = price;
    var pd = q('[data-wsh-guitar-price-desktop]'); if (pd) pd.textContent = price;
    var cta = q('[data-wsh-guitar-cta]');
    if (cta) { cta.setAttribute('href', lib.url); cta.setAttribute('target', '_blank'); cta.setAttribute('rel', 'noopener'); }
    var ctaD = q('[data-wsh-guitar-cta-desktop]');
    if (ctaD) { ctaD.setAttribute('href', lib.url); ctaD.setAttribute('target', '_blank'); ctaD.setAttribute('rel', 'noopener'); }
    var cyc = q('[data-wsh-guitar-cycle]');
    cyc.innerHTML = '';
    /* Closing-fix item 6: match the three-cards switcher — SHOW ME ANOTHER
     * button carries the same ↻ SVG; swatches have their background-image
     * on the BUTTON itself (not an inner span, which collapsed to 0×0 width
     * because the inline <span> had no intrinsic size). Also render an
     * "N of 3" counter so the row reads like the cards. */
    var btn = ce('button', 'wsh-fys-card__show-another');
    btn.type = 'button';
    btn.setAttribute('data-wsh-show-another', 'guitar');
    btn.innerHTML = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 4v5h-5"/></svg><span>SHOW ME ANOTHER</span>';
    cyc.appendChild(btn);
    var swatchRow = ce('div', 'wsh-fys-card__swatch-row');
    for (var i = 0; i < Math.min(opts.length, 3); i++) {
      var optLib = data.libraries[opts[i].handle];
      var s = ce('button', 'wsh-fys-card__swatch' + (i === idx ? ' wsh-fys-card__swatch--active' : ''));
      s.type = 'button';
      s.setAttribute('data-wsh-guitar-pick', String(i));
      s.setAttribute('aria-label', optLib ? ('Show ' + optLib.title) : ('Show option ' + (i + 1)));
      if (optLib) {
        var stu = optLib.tier_1_card_image_url || optLib.featured_image_url;
        if (stu) s.style.backgroundImage = 'url(' + stu + ')';
      }
      swatchRow.appendChild(s);
    }
    swatchRow.appendChild(ce('span', 'wsh-fys-card__idx-label', (idx + 1) + ' of ' + Math.min(opts.length, 3)));
    cyc.appendChild(swatchRow);
    // Cart slice: with one suggestion left there is nothing else to show.
    cyc.hidden = opts.length < 2;
  }

  function chooseSharedBundle(shown) {
    // Section 2: "The shared strip ignores owned libraries." Only count
    // unowned libraries toward shared-bundle membership.
    var handles = shown.filter(function (l) { return !isOwned(l.handle); }).map(function (l) { return l.handle; });
    var cbs = (data && data.curated_bundles) || {};
    var candidates = [];
    Object.keys(cbs).forEach(function (bh) {
      var b = cbs[bh];
      if (isOwned(b.handle)) return; // skip bundles the user owns
      var kids = (b.children || []).filter(function (h) { return handles.indexOf(h) !== -1; });
      if (kids.length >= 2) candidates.push({ bundle: b, matched: kids });
    });
    if (!candidates.length) return null;
    var matchLib = shown[0];
    var matchFeatured = matchLib.featured_bundle_handle || '';
    candidates.sort(function (a, b) {
      if (a.bundle.handle === matchFeatured && b.bundle.handle !== matchFeatured) return -1;
      if (b.bundle.handle === matchFeatured && a.bundle.handle !== matchFeatured) return 1;
      if (b.matched.length !== a.matched.length) return b.matched.length - a.matched.length;
      return (Number(a.bundle.price_cents) || 0) - (Number(b.bundle.price_cents) || 0);
    });
    return candidates[0].bundle;
  }

  function renderStrip(shown) {
    // Section 2: BYO strip uses only the UNOWNED shown libraries.
    //  3 left → "Build Your Own Bundle" with full 3-pack 15% off.
    //  2 left → "Get both together" 10% off.
    //  1 or 0 left → hide the strip entirely.
    var unowned = shown.filter(function (l) { return !isOwned(l.handle); });
    var sharedBundle = chooseSharedBundle(shown);
    var sharedWrap = q('[data-wsh-strip-shared]');
    var byoWrap = q('[data-wsh-strip-byo]');
    if (sharedBundle) {
      byoWrap.hidden = true;
      sharedWrap.hidden = false;
      var img = q('[data-wsh-shared-img]');
      if (sharedBundle.image_url) {
        img.style.backgroundImage = 'url(' + sharedBundle.image_url + ')';
        img.textContent = '';
      }
      var childCount = Number(sharedBundle.children_count) || 0;
      var save = bundleDiscount(childCount);
      // Item 9: match first, then the other library in the shown trio that this
      // bundle also holds. Preserve shown-order for any additional matches.
      var shownHandles = shown.map(function (s) { return s.handle; });
      var childrenSet = (sharedBundle.children || []);
      var matchedOrdered = shownHandles.filter(function (h) { return childrenSet.indexOf(h) !== -1; });
      var matchedTitles = matchedOrdered.map(function (h) { var l = data.libraries[h]; return l ? l.title : h; });
      var fullTitle = bundleFullTitle(sharedBundle.title);
      var line = 'The ' + fullTitle + ' holds ';
      if (matchedTitles.length === 2) line += matchedTitles[0] + ' and ' + matchedTitles[1];
      else if (matchedTitles.length >= 3) line += matchedTitles.slice(0, -1).join(', ') + ' and ' + matchedTitles[matchedTitles.length - 1];
      else line += matchedTitles[0] || '';
      q('[data-wsh-shared-line]').textContent = line;
      // Item 9 + C.17 (Rev 3 follow-up): subline source — bundle metaobject's
      // bundle_description first, then the bundle PRODUCT's soundbar_subtitle
      // as fallback (endpoint carries both). Empty-both bundles show no subline.
      var sharedSub = sharedBundle.description && String(sharedBundle.description).trim();
      if (!sharedSub) sharedSub = sharedBundle.product_soundbar_subtitle && String(sharedBundle.product_soundbar_subtitle).trim();
      q('[data-wsh-shared-sub]').textContent = sharedSub || '';
      // CL-4 (2026-10-26, Phil Call B): shared-bundle price uses the
      // per-line rounded sum from children, not the bundle PRODUCT's own
      // published price. Match checkout to the cent. Fall back to the
      // published price_cents if children prices aren't on the endpoint
      // (older FYS payloads).
      var sharedChildPrices = [];
      if (Array.isArray(sharedBundle.children) && sharedBundle.children.length) {
        sharedChildPrices = sharedBundle.children.map(function (c) { return Number(c.price_cents) || 0; });
      } else if (Array.isArray(sharedBundle.child_price_cents) && sharedBundle.child_price_cents.length) {
        sharedChildPrices = sharedBundle.child_price_cents.map(function (c) { return Number(c) || 0; });
      }
      var sharedPctInt = parseInt(String(save).replace('%',''), 10) || 0;
      var sharedCents = (sharedChildPrices.length >= 2 && window.wshBundleTotalCents)
        ? window.wshBundleTotalCents(sharedChildPrices, sharedPctInt)
        : (Number(sharedBundle.price_cents) || 0);
      q('[data-wsh-shared-price]').textContent = formatMoney(sharedCents);
      q('[data-wsh-shared-save]').textContent = 'SAVE ' + save;
      var cta = q('[data-wsh-shared-cta]');
      cta.setAttribute('href', sharedBundle.url);
      cta.textContent = 'SEE THE ' + fullTitle.toUpperCase();
      // P2 §D7: new tab + pause.
      cta.setAttribute('target', '_blank');
      cta.setAttribute('rel', 'noopener');
      return;
    }
    sharedWrap.hidden = true;
    // Section 2 (Phil 2026-10-01 pm): BYO builds from UNOWNED shown only.
    // 0 or 1 → hide the strip (nothing to bundle).
    if (unowned.length < 2) {
      byoWrap.hidden = true;
      return;
    }
    byoWrap.hidden = false;
    var thumbsEl = q('[data-wsh-byo-thumbs]');
    thumbsEl.innerHTML = '';
    unowned.forEach(function (lib) {
      var t = ce('span', 'wsh-fys-strip__thumb');
      var u = lib.tier_1_card_image_url || lib.featured_image_url;
      if (u) t.style.backgroundImage = 'url(' + u + ')';
      thumbsEl.appendChild(t);
    });
    var titles = unowned.map(function (l) { return l.title; });
    var line;
    if (unowned.length === 2) line = 'Get both together: ' + titles[0] + ' and ' + titles[1];
    else if (titles.length === 3) line = 'Build Your Own Bundle: ' + titles[0] + ', ' + titles[1] + ' and ' + titles[2];
    else line = 'Build Your Own Bundle: ' + titles.join(', ');
    q('[data-wsh-byo-line]').textContent = line;
    // CL-4 (2026-10-26, Phil Call B): per-line rounded sum via the shared
    // helper. 2-of-3 remaining → 10%; 3 → 15%. Matches checkout per line
    // and reconciles with the card's bundle price in collection grids.
    var byoChildPrices = unowned.map(function (l) { return Number(l.price_cents) || 0; });
    var byoPct = unowned.length === 2 ? 10 : 15;
    var byoTotal = (window.wshBundleTotalCents || function(cs){ return cs.reduce(function(a,c){ return a+c; },0); })(byoChildPrices, byoPct);
    q('[data-wsh-byo-price]').textContent = formatMoney(byoTotal);
    var saveEl = q('.wsh-fys-strip__save--rust');
    if (saveEl) saveEl.textContent = 'SAVE ' + (unowned.length === 2 ? '10%' : '15%');
  }

  function renderClaim(answers) {
    // FYS-3B-1b (Phil 2026-10-03, built 2026-10-07): the offer is for
    // everyone, once, buyers included. The block is hidden only for a
    // signed-in visitor whose orders already hold Audition Sessions
    // ("claimed" from ?view=fys-owned).
    var claimHost = q('[data-wsh-claim]');
    var hasClaimed = !!(owned && owned.signed_in && owned.claimed === true);
    if (claimHost) claimHost.hidden = hasClaimed;
    if (hasClaimed) {
      try { __fysClaim.onHidden(); } catch (e) { /* noop */ }
      return;
    }
    var samp = claimSetFor(answers);
    if (!samp) { if (claimHost) claimHost.hidden = true; return; }

    // FYS-3B-1a A2 (last bullet) — hide the block entirely when the variant
    // id for the visitor's format is missing or not a positive whole number.
    // No call will be made from a hidden block (submit listener early-returns
    // when the host is hidden, too).
    var variantId = samp.variant_id;
    var variantOk = (typeof variantId === 'number') && (variantId > 0) && Number.isInteger(variantId);
    if (!variantOk) {
      if (claimHost) claimHost.hidden = true;
      return;
    }

    var daw = answers.daw || 'Cubase';
    var isWavDaw = dawIsWavOnlyDaw(daw);

    // FYS-3B-1a A1 — read data-fys-kits on every render; '4' means four,
    // anything else means three. Phil can flip the setting without a redeploy.
    var kitsAttr = root.getAttribute('data-fys-kits');
    var isFour = (kitsAttr === '4');
    var kitsLimit = isFour ? 4 : 3;
    // Audition Sessions slice: the words follow the kits actually shown
    // (every set holds three), so "four" never sits over three tiles.
    var kitsShown = Math.min(kitsLimit, (samp.kits || []).length);
    var KIT_WORDS = ['', 'one', 'two', 'three', 'four'];
    var kitsLow = KIT_WORDS[kitsShown] || (isFour ? 'four' : 'three');
    var kitsCap = kitsLow.charAt(0).toUpperCase() + kitsLow.slice(1);

    var title = q('[data-wsh-claim-title]');
    if (title) title.textContent = 'Try ' + kitsLow + ' kits in your DAW';

    // Audition Sessions slice: name the visitor's set above the kits
    // ("Rock · Drums Only"). Hidden when the Sampler is the fallback.
    var setLine = q('[data-wsh-claim-set]');
    if (setLine) {
      if (samp.isSet && samp.genre && samp.format) {
        setLine.textContent = samp.genre + ' \u00b7 ' + samp.format;
        setLine.hidden = false;
      } else {
        setLine.textContent = '';
        setLine.hidden = true;
      }
    }

    var body = q('[data-wsh-claim-body]');
    if (body) {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
      var shortCopy = isWavDaw
        ? kitsCap + ' kits from ' + kitsLow + ' of our libraries, as WAV, ready to drag and drop into any DAW. Real players, real rooms, real tone.'
        : kitsCap + ' kits from ' + kitsLow + ' of our libraries, ready to open in ' + daw + '. Real players, real rooms, real tone.';
      var longCopy = shortCopy + ' Open them in your DAW and hear the difference.';
      body.textContent = isMobile ? shortCopy : longCopy;
    }

    var kitsWrap = q('[data-wsh-claim-kits]');
    if (kitsWrap) {
      kitsWrap.innerHTML = '';
      // A2 last bullet: "If the listing holds fewer kits than the number,
      // show the ones it holds." slice(0, N) does exactly this.
      (samp.kits || []).slice(0, kitsLimit).forEach(function (k) {
        var kit = ce('div', 'wsh-fys-claim__kit');
        var kim = ce('span', 'wsh-fys-claim__kit-image');
        if (k.image_url) kim.style.backgroundImage = 'url(' + k.image_url + ')';
        kit.appendChild(kim);
        // A2 tile-tag — three-kits uses "1 KIT · <DAW>"; four-kits uses "<DAW>"
        // alone. WAV variants (Other / FL Studio) substitute "WAV" for the DAW.
        var dawPart = isWavDaw ? 'WAV' : daw.toUpperCase();
        var kitLabel = isFour ? dawPart : ('1 KIT · ' + dawPart);
        kit.appendChild(ce('span', 'wsh-fys-claim__kit-label', kitLabel));
        kit.appendChild(ce('span', 'wsh-fys-claim__kit-name', k.title));
        kitsWrap.appendChild(kit);
      });
    }

    var soon = q('[data-wsh-claim-soon]');
    if (soon) {
      if (isWavDaw) {
        soon.hidden = true;
      } else if (scoreResult && scoreResult.match) {
        var matchLib = data.libraries[scoreResult.match.handle];
        var hasDaw = matchLib && matchLib.daw_sessions && matchLib.daw_sessions.some(function (d) { return d.label === daw && d.has_session; });
        if (!hasDaw) {
          soon.textContent = "Where a session isn't ready in " + daw + " yet, you'll get WAV to drag and drop now.";
          soon.hidden = false;
        } else {
          soon.hidden = true;
        }
      }
    }

    // FYS-3B-1a §B7 — reconcile the block's state against the run id and
    // prime the seen-observer. If the run id has changed since the last render
    // (fingerprint change: a new answer touched one of the keyed fields), any
    // in-flight call aborts and the block returns to the guest state. Same
    // run id = leave state (typed address, waiting, already-claimed) alone.
    try { __fysClaim.reconcileForRun(variantId); } catch (e) { /* noop */ }
  }

  function renderFooter(answers) {
    // Item 4: footer genre comes from the MATCH library (which reflects what the
    // customer actually landed on), not the raw quiz genre — a cinematic match
    // like Lift under a "Country" quiz answer must read Cinematic here.
    var matchLib = scoreResult && scoreResult.match && data.libraries[scoreResult.match.handle];
    var genreName = (matchLib && GENRE_NAME[matchLib.genre_collection_handle])
                 || GENRE_NAME[answers.genre]
                 || 'Country';
    var url = GENRE_URL[genreName] || '/collections/all';
    var sub = q('[data-wsh-foot-sub]');
    var browse = q('[data-wsh-browse-genre]');
    if (sub) sub.textContent = 'Try another genre, or browse every ' + genreName + ' library.';
    if (browse) {
      browse.textContent = 'SEE ALL ' + genreName.toUpperCase() + ' LIBRARIES →';
      browse.setAttribute('href', url);
      // P2 §D7: new tab + pause.
      browse.setAttribute('target', '_blank');
      browse.setAttribute('rel', 'noopener');
    }
  }

  function applyTab(name) {
    ui.tab = name;
    qa('[data-wsh-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-wsh-tab') === name ? 'true' : 'false');
    });
    qa('.wsh-fys-card', root).forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-wsh-card') === name);
    });
    qa('[data-wsh-dot]').forEach(function (d) {
      d.classList.toggle('is-active', d.getAttribute('data-wsh-dot') === name);
    });
  }

  // ── Audio engine ─────────────────────────────────────────────────────
  // Primary path: delegate playback to the site soundbar (wsh-audio-manager
  // app-extension custom element). All five FYS result controls (picked,
  // 3 match cards, guitar) call mgr.loadAndPlay({...}) directly — NOT via
  // the .play__audio delegated handler, which would build a playlist from
  // every button on the page.
  //
  // Fallback: Section A HTMLAudioElement path (fysAudio) stays as a safety
  // net if <wsh-audio-manager> fails to load.
  //
  // State mirror: listen to document-level wsh:audio:play / pause /
  // track-change events. Our track objects carry a _fysSource marker so
  // we can tell "our" plays from any other page audio.
  var fysAudio = null;    // fallback-only: { el, sourceKey, url }
  var currentSourceKey = null;
  Object.defineProperty(window, '__wshFysCurrentAudio', {
    get: function () { return fysAudio ? fysAudio.el : null; },
    configurable: true,
  });

  function getAudioManager() {
    return document.querySelector('wsh-audio-manager');
  }

  // Build a soundbar track object from a library row. gainDb only used for
  // the picked kit; other sources omit it (soundbar defaults volume to 1.0).
  function trackForLibrary(lib, sourceKey, gainDb) {
    if (!lib) return null;
    var url = lib.overview_url || lib.first_kit_url || lib.hear_url;
    if (!url) return null;
    var abs = url.indexOf('//') === 0 ? 'https:' + url : url;
    var peaks = lib.hear_peaks_url || url.replace(/\.mp3(\?|$)/, '.mp3.json$1');
    if (peaks && peaks.indexOf('//') === 0) peaks = 'https:' + peaks;
    var track = {
      trackUrl: abs,
      peaksUrl: peaks,
      trackName: 'Demo',
      recordName: lib.title || '',
      recordCover: lib.tier_1_card_image_url || lib.featured_image_url || '',
      productUrl: lib.url || '',
      subtitle: lib.soundbar_subtitle || '',
      // Brief §3.B.6: waveform colours resolve from FYS tokens (no literals).
      // Soundbar always sits on dark; progress = --fys-on-dark, wave = same at 30%.
      progressColor: _fysOnDarkHex(),
      waveColor: _fysOnDarkRgba(0.3),
      // ATC fields (brief Rev 3 S4 follow-up): fys-data endpoint now carries
      // variant_id + product_id + highlight_color per library so the soundbar's
      // Add to Cart button has a real variant to POST to /cart/add.js.
      price: lib.price_cents != null ? String(lib.price_cents) : '',
      compareAtPrice: lib.compare_at_price_cents != null ? String(lib.compare_at_price_cents) : '',
      variantId: lib.variant_id != null ? String(lib.variant_id) : '',
      productId: lib.product_id != null ? String(lib.product_id) : '',
      productType: lib.type || '',
      _fysSource: sourceKey,
      _fysLibraryHandle: lib.handle || '',  // Section 5: same-library PAUSE mirror
    };
    if (typeof gainDb === 'number' && isFinite(gainDb)) track.gain_db = gainDb;
    return track;
  }

  // Build the picked-kit track: picked tile's clip + gain; anchor library's
  // metadata for the soundbar display.
  function trackForPicked() {
    var state = (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState()) || {};
    var pick = state.pick;
    if (!pick) return null;
    // Slice 3: a run reopened from the reminder link knows the library picked,
    // not the tile: the library's own sound plays.
    if (!pick.tile) {
      var pl = pick.library_handle && data && data.libraries[pick.library_handle];
      return pl ? trackForLibrary(pl, 'picked') : null;
    }
    var tile = window.__wshFys && window.__wshFys.getPickedTile
      ? window.__wshFys.getPickedTile({ tile: pick.tile, group: pick.group, set_key: state.set_key })
      : null;
    var anchorHandle = pick.library_handle || (tile && tile.library_handle);
    var anchorLib = anchorHandle && data && data.libraries[anchorHandle];
    if (tile && tile.clip_url) {
      var track = trackForLibrary(anchorLib, 'picked', tile.gain_db);
      if (track) {
        var clipAbs = tile.clip_url.indexOf('//') === 0 ? 'https:' + tile.clip_url : tile.clip_url;
        var peaks = tile.peaks_url || tile.clip_url.replace(/\.mp3(\?|$)/, '.mp3.json$1');
        if (peaks && peaks.indexOf('//') === 0) peaks = 'https:' + peaks;
        track.trackUrl = clipAbs;
        track.peaksUrl = peaks;
        return track;
      }
    }
    // Last-resort: anchor library's overview (no gain).
    if (anchorLib) return trackForLibrary(anchorLib, 'picked');
    return null;
  }

  // Fallback (Section A) engine — unchanged shape, used only when soundbar missing.
  function fallbackPlayAudio(url, gainDb, sourceKey) {
    if (!url) return;
    try { document.dispatchEvent(new CustomEvent('product:audio:pause')); } catch (e) { /* noop */ }
    try { document.dispatchEvent(new CustomEvent('videos:pause')); } catch (e) { /* noop */ }
    try { document.dispatchEvent(new CustomEvent('wsh-fys:audio:pause', { detail: { source: 'fys-results' } })); } catch (e) { /* noop */ }
    if (fysAudio && fysAudio.el) { try { fysAudio.el.pause(); } catch (e) { /* noop */ } }
    var normalized = url.indexOf('//') === 0 ? 'https:' + url : url;
    var el = new Audio();
    el.preload = 'auto';
    el.src = normalized;
    var g = Number(gainDb) || 0;
    el.volume = Math.min(1, Math.pow(10, g / 20));
    fysAudio = { el: el, sourceKey: sourceKey, url: normalized };
    el.addEventListener('ended', function () {
      if (fysAudio && fysAudio.el === el) { fysAudio = null; ui.playing = null; updatePlayPills(); }
    });
    el.addEventListener('pause', function () {
      if (fysAudio && fysAudio.el === el && !el.ended && ui.playing === sourceKey) {
        ui.playing = null; updatePlayPills();
      }
    });
    ui.playing = sourceKey;
    updatePlayPills();
    var pr = el.play();
    if (pr && typeof pr.catch === 'function') {
      pr.catch(function (err) {
        console.warn('[FYS] fallback audio play rejected:', err && err.message);
        if (fysAudio && fysAudio.el === el) { fysAudio = null; ui.playing = null; updatePlayPills(); }
      });
    }
  }

  function stopFallback() {
    if (fysAudio && fysAudio.el) {
      try { fysAudio.el.pause(); } catch (e) { /* noop */ }
      try { fysAudio.el.currentTime = 0; } catch (e) { /* noop */ }
    }
    fysAudio = null;
  }

  // Mutex: honour page-level pause events for the fallback engine only.
  // (The audio-manager already honours product:audio:pause + videos:pause
  // itself; it dispatches wsh:audio:pause when it pauses, which we handle
  // via the mirror listeners below.)
  document.addEventListener('product:audio:pause', function () {
    if (!getAudioManager()) { stopFallback(); ui.playing = null; updatePlayPills(); }
  });
  document.addEventListener('videos:pause', function () {
    if (!getAudioManager()) { stopFallback(); ui.playing = null; updatePlayPills(); }
  });

  // State-mirror from the soundbar.
  // _fysSource ride-along on our track objects lets us tell "our" plays from
  // any other page audio the manager might be driving (none on FYS today).
  document.addEventListener('wsh:audio:play', function (e) {
    var tr = e && e.detail && e.detail.track;
    var src = tr && tr._fysSource;
    ui.playing = src || null;
    currentSourceKey = ui.playing;
    currentPlayingHandle = (tr && tr._fysLibraryHandle) || null;
    updatePlayPills();
  });
  document.addEventListener('wsh:audio:pause', function () {
    ui.playing = null;
    currentSourceKey = null;
    currentPlayingHandle = null;
    updatePlayPills();
  });
  document.addEventListener('wsh:audio:track-change', function (e) {
    var tr = e && e.detail && e.detail.track;
    var src = tr && tr._fysSource;
    ui.playing = src || null;
    currentSourceKey = ui.playing;
    currentPlayingHandle = (tr && tr._fysLibraryHandle) || null;
    updatePlayPills();
  });

  function playTrack(track, sourceKey) {
    if (!track) return;
    var mgr = getAudioManager();
    if (mgr && typeof mgr.loadAndPlay === 'function') {
      currentSourceKey = sourceKey;
      try { mgr.loadAndPlay(track); } catch (err) {
        console.warn('[FYS] soundbar loadAndPlay threw, falling back:', err && err.message);
        fallbackPlayAudio(track.trackUrl, track.gain_db, sourceKey);
      }
      return;
    }
    console.warn('[FYS] soundbar not loaded — falling back to inline engine');
    fallbackPlayAudio(track.trackUrl, track.gain_db, sourceKey);
  }

  function pausePlay() {
    var mgr = getAudioManager();
    if (mgr && typeof mgr.pause === 'function') {
      try { mgr.pause(); } catch (e) { /* noop */ }
      return;
    }
    stopFallback();
    ui.playing = null;
    updatePlayPills();
  }

  // Picked-by-ear.
  function playPicked() {
    var track = trackForPicked();
    if (!track) return;
    playTrack(track, 'picked');
  }

  // Card / guitar: overview → first kit (gain 0 dB — no per-library gain).
  function playLibrary(handle, sourceKey) {
    var lib = data && data.libraries[handle];
    if (!lib) return;
    var track = trackForLibrary(lib, sourceKey);
    if (!track) return;
    playTrack(track, sourceKey);
  }
  function playPreview(handle, sourceKey) { playLibrary(handle, sourceKey); }

  // Legacy name kept for the handful of call sites in wireEvents() that use
  // "stop" semantics on cycle/thumbnail/tab switch. Routes through pausePlay
  // so the bar pauses (the brief: "Stop rules → pause() the bar").
  function stopPlay() { pausePlay(); }

  // Section 5 (Phil 2026-10-01 pm): same-library PAUSE mirror. While ANY
  // track from a given library is playing in the bar (picked kit OR overview),
  // every button on the page that represents that library shows PAUSE.
  // currentPlayingHandle is cached from wsh:audio:play/track-change events.
  var currentPlayingHandle = null;
  function pickedLibHandle() {
    var s = (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState()) || {};
    return s.pick && s.pick.library_handle || null;
  }
  function cardLibHandle(role) {
    if (!scoreResult) return null;
    if (role === 'match' && scoreResult.match) return scoreResult.match.handle;
    if (role === 'next') { var n = scoreResult.next && scoreResult.next.options[ui.nIdx]; return n && n.handle; }
    if (role === 'wildcard') { var w = scoreResult.wildcard && scoreResult.wildcard.options[ui.wIdx]; return w && w.handle; }
    return null;
  }
  function guitarLibHandle() {
    if (!scoreResult || !scoreResult.guitar_layer) return null;
    var g = scoreResult.guitar_layer.options[ui.gIdx];
    return g && g.handle;
  }

  function updatePlayPills() {
    var playingH = currentPlayingHandle;
    var pickedBtn = q('[data-wsh-picked-play]');
    if (pickedBtn) {
      // The picked panel's PAUSE shows when the bar is playing EITHER the
      // picked tile (ui.playing==='picked') OR the picked library's overview
      // (same-library rule).
      var pickedLib = pickedLibHandle();
      var pickedActive = ui.playing === 'picked' || (!!pickedLib && pickedLib === playingH);
      pickedBtn.classList.toggle('is-playing', pickedActive);
      var lbl = q('[data-wsh-picked-play-label]', pickedBtn);
      if (lbl) lbl.textContent = pickedActive ? 'PAUSE' : 'PLAY YOUR PICK';
    }
    ['match', 'next', 'wildcard'].forEach(function (role) {
      var card = q('[data-wsh-card="' + role + '"]');
      if (!card) return;
      var btn = q('[data-wsh-card-play]', card);
      if (!btn) return;
      var libH = cardLibHandle(role);
      // Card plays its own overview sourceKey, OR matches the currently-playing
      // library handle (e.g. the picked kit is this card's library — same-lib).
      var active = ui.playing === 'card-' + role || (!!libH && libH === playingH);
      btn.classList.toggle('is-playing', active);
      var lbl = q('[data-wsh-card-play-label]', btn);
      if (lbl) lbl.textContent = active ? 'PAUSE' : 'HEAR THE LIBRARY';
    });
    var gLibH = guitarLibHandle();
    var gActive = ui.playing === 'guitar' || (!!gLibH && gLibH === playingH);
    ['[data-wsh-guitar-play]', '[data-wsh-guitar-play-desktop]'].forEach(function (sel) {
      var b = q(sel);
      if (!b) return;
      b.classList.toggle('is-playing', gActive);
    });
    ['[data-wsh-guitar-play-label]', '[data-wsh-guitar-play-label-desktop]'].forEach(function (sel) {
      var l = q(sel);
      if (l) l.textContent = gActive ? 'PAUSE' : 'HEAR IT';
    });
  }

  function newBundleToken() {
    return 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6);
  }

  function shownTrio() {
    if (!scoreResult) return [];
    var out = [];
    var matchLib = data.libraries[scoreResult.match.handle];
    var nextO = scoreResult.next.options[ui.nIdx] || scoreResult.next.options[0];
    var wildO = scoreResult.wildcard.options[ui.wIdx] || scoreResult.wildcard.options[0];
    if (matchLib) out.push(matchLib);
    if (nextO) out.push(data.libraries[nextO.handle]);
    if (wildO) out.push(data.libraries[wildO.handle]);
    return out.filter(Boolean);
  }

  // P2 §D10: BUNDLE ALL THREE adds the variant the product page's own ATC
  // adds by default. The fys-data endpoint carries lib.variant_id, which is
  // Liquid's selected_or_first_available_variant.id — same as the PDP buy-box
  // default. Prefer it; fall back to a /products/{handle}.js first-available
  // lookup only when variant_id is missing (shouldn't happen on live catalog).
  function firstAvailableVariantId(lib) {
    if (lib.variant_id) return Promise.resolve(Number(lib.variant_id));
    if (!lib.__variant_id_promise) {
      lib.__variant_id_promise = fetch(lib.url + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).find(function (v) { return v.available; }) || p.variants[0];
          return v ? v.id : null;
        });
    }
    return lib.__variant_id_promise;
  }

  // Cart slice: an add from BUNDLE ALL THREE that is still on its way to the
  // cart. The claim never opens the claim link while one is (see onSubmit).
  var byoInFlight = 0;
  var byoStartedAt = 0;
  // 30 s: the add may first wait for other cart changes to end (slice 2 fix).
  function byoAddOnItsWay() { return byoInFlight > 0 && (Date.now() - byoStartedAt) < 30000; }
  function doByoAdd() {
    // Section 2: BYO Add to Cart posts only the UNOWNED shown libraries.
    var trio = shownTrio().filter(function (l) { return !isOwned(l.handle); });
    if (!trio.length) return;
    bundleToken = newBundleToken();
    byoInFlight++;
    byoStartedAt = Date.now();
    // Follow-up: a Sampler left by an unfinished claim comes out first.
    var leftoverP, removedLeftover = false, announced = false;
    try { leftoverP = __fysClaim.removeLeftoverSampler(); } catch (e) { leftoverP = Promise.resolve(false); }
    Promise.all([leftoverP].concat(trio.map(firstAvailableVariantId))).then(function (all) {
      removedLeftover = !!all[0];
      var ids = all.slice(1);
      var items = ids.filter(Boolean).map(function (id) {
        return {
          id: id,
          quantity: 1,
          properties: {
            _bundle_token: bundleToken,
            _bundle_page: 'fys-results',
            _bundle_source: 'fys_results',
          },
        };
      });
      if (!items.length) return;
      // Slice 2 fix: no other cart change is out when this add goes (at most 8 s).
      var waitQ; try { waitQ = __fysClaim.waitCartQuiet(8000); } catch (e) { waitQ = Promise.resolve(); }
      var cartFetch; try { cartFetch = __fysClaim.ourCartFetch; } catch (e) { cartFetch = null; }
      return waitQ.then(function () { return (cartFetch || fetch)('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) { return r.json(); }); });
    }).then(function (cartData) {
      if (!cartData) return;
      announced = true;
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cartData, sourceId: 'fys-byo', data: { source: 'fys-byo' } };
      document.dispatchEvent(ev);
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') {
        try { drawer.showDialog(); } catch (e) { /* noop */ }
      }
    }).catch(function (err) {
      console.error('[FYS] BYO add failed:', err);
    }).then(function () {
      byoInFlight = Math.max(0, byoInFlight - 1);
      // The Sampler came out but nothing was added: the cart on screen follows.
      if (removedLeftover && !announced) { try { __fysClaim.announceCartChange(); } catch (e) { /* noop */ } }
      // Done, added or not: bring the claim block up to date with the cart.
      try { __fysClaim.refreshCart(); } catch (e) { /* noop */ }
    });
  }

  function wireEvents() {
    qa('[data-wsh-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        // Tab switch stops audio (Phil A3).
        if (ui.playing && String(ui.playing).indexOf('card-') === 0) stopPlay();
        applyTab(b.getAttribute('data-wsh-tab'));
      });
    });
    // Rev 3 v3 board (brief 5): image + title cross-fade on option change
    // (~200ms). Add .is-swapping to the affected card; CSS transitions image
    // + title-block opacity to 0; after a frame, swap data; next frame, drop
    // the class so opacity returns to 1.
    function swapCardWithFade(roleOrGuitar, swap) {
      var card = roleOrGuitar === 'guitar'
        ? q('[data-wsh-guitar]')
        : q('[data-wsh-card="' + roleOrGuitar + '"]');
      if (!card) { swap(); return; }
      card.classList.add('is-swapping');
      requestAnimationFrame(function () {
        setTimeout(function () {
          swap();
          requestAnimationFrame(function () { card.classList.remove('is-swapping'); });
        }, 150);
      });
    }
    root.addEventListener('click', function (e) {
      var another = e.target.closest && e.target.closest('[data-wsh-show-another]');
      if (another) {
        var role = another.getAttribute('data-wsh-show-another');
        // Cycling any role stops audio for that role's current source
        // (Phil A3: "…stops whatever that card was playing and loads the new
        // library's source. The button resets to ▶.").
        var cycleKey = role === 'guitar' ? 'guitar' : 'card-' + role;
        if (ui.playing === cycleKey) stopPlay();
        if (role === 'next') {
          swapCardWithFade('next', function () {
            // P2 §D9: cycle through the first three options only so the
            // "N of 3" label and the three swatches always agree.
            var n = Math.min(scoreResult.next.options.length, 3);
            ui.nIdx = (ui.nIdx + 1) % Math.max(n, 1);
            rerenderTrio();
          });
        } else if (role === 'wildcard') {
          swapCardWithFade('wildcard', function () {
            var w = Math.min(scoreResult.wildcard.options.length, 3);
            ui.wIdx = (ui.wIdx + 1) % Math.max(w, 1);
            rerenderTrio();
          });
        } else if (role === 'guitar') {
          swapCardWithFade('guitar', function () {
            var g = Math.min(scoreResult.guitar_layer.options.length, 3);
            ui.gIdx = (ui.gIdx + 1) % Math.max(g, 1);
            renderGuitarCard();
          });
        }
        return;
      }
      var swatch = e.target.closest && e.target.closest('[data-wsh-swatch]');
      if (swatch) {
        var srole = swatch.getAttribute('data-wsh-swatch');
        var sidx = parseInt(swatch.getAttribute('data-wsh-swatch-idx'), 10) || 0;
        var swatchKey = 'card-' + srole;
        if (ui.playing === swatchKey) stopPlay();
        swapCardWithFade(srole, function () {
          if (srole === 'next') ui.nIdx = sidx;
          else if (srole === 'wildcard') ui.wIdx = sidx;
          rerenderTrio();
        });
        return;
      }
      var gpick = e.target.closest && e.target.closest('[data-wsh-guitar-pick]');
      if (gpick) {
        if (ui.playing === 'guitar') stopPlay();
        swapCardWithFade('guitar', function () {
          ui.gIdx = parseInt(gpick.getAttribute('data-wsh-guitar-pick'), 10) || 0;
          renderGuitarCard();
        });
        return;
      }
      var byoBtn = e.target.closest && e.target.closest('[data-wsh-byo-cta]');
      if (byoBtn) { e.preventDefault(); doByoAdd(); return; }
      var pickedPlay = e.target.closest && e.target.closest('[data-wsh-picked-play]');
      if (pickedPlay) {
        // Section 5 same-library rule: pause if the picked kit's library is
        // currently playing in the bar (via any button), not only if the
        // picked button itself triggered the play.
        var pickedLibH = pickedLibHandle();
        if (ui.playing === 'picked' || (pickedLibH && currentPlayingHandle === pickedLibH)) pausePlay();
        else playPicked();
        return;
      }
      var cardPlay = e.target.closest && e.target.closest('[data-wsh-card-play]');
      if (cardPlay) {
        var pcard = cardPlay.closest('[data-wsh-card]');
        var role2 = pcard && pcard.getAttribute('data-wsh-card');
        var lib = null;
        if (role2 === 'match' && scoreResult && scoreResult.match) lib = data.libraries[scoreResult.match.handle];
        else if (role2 === 'next' && scoreResult) {
          var nopt = scoreResult.next.options[ui.nIdx] || scoreResult.next.options[0];
          if (nopt) lib = data.libraries[nopt.handle];
        } else if (role2 === 'wildcard' && scoreResult) {
          var wopt = scoreResult.wildcard.options[ui.wIdx] || scoreResult.wildcard.options[0];
          if (wopt) lib = data.libraries[wopt.handle];
        }
        if (!lib) return;
        var key = 'card-' + role2;
        // Same-library rule: pressing a card whose library is currently
        // playing pauses the bar, regardless of which source triggered the
        // play. Covers "match card shows PAUSE while picked kit plays"
        // (picked kit is match's library).
        if (ui.playing === key || currentPlayingHandle === lib.handle) pausePlay();
        else playPreview(lib.handle, key);
        return;
      }
      var gpl = e.target.closest && (e.target.closest('[data-wsh-guitar-play]') || e.target.closest('[data-wsh-guitar-play-desktop]'));
      if (gpl) {
        var gopts = scoreResult && scoreResult.guitar_layer && scoreResult.guitar_layer.options;
        if (!gopts || !gopts.length) return;
        var glib = data.libraries[gopts[ui.gIdx % gopts.length].handle];
        if (!glib) return;
        if (ui.playing === 'guitar' || currentPlayingHandle === glib.handle) pausePlay();
        else playPreview(glib.handle, 'guitar');
        return;
      }
    });
    // P2 §C12: the results script's exit handler is retired — the quiz's
    // handler (wsh-fys.js [data-wsh-fys-exit]) is the only one, honours
    // ?from= + referrer, and pauses all FYS audio before navigating.

    // P2 §D7: product-link clicks pause the results soundbar. The links
    // themselves carry target="_blank" rel="noopener" (set in the renderers),
    // so this handler never preventDefaults — the new tab opens and the
    // results tab's audio pauses behind it.
    var NEW_TAB_SEL = [
      '[data-wsh-card-cta]',
      '[data-wsh-guitar-cta]',
      '[data-wsh-guitar-cta-desktop]',
      '[data-wsh-shared-cta]',
      '[data-wsh-browse-genre]',
      'a.wsh-fys-panel',
      '[data-wsh-claim-already-cta]',
    ].join(', ');
    root.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest(NEW_TAB_SEL);
      if (!link) return;
      // Only pause for real new-tab links; skip owned-match "FIND ANOTHER SOUND"
      // (an in-tab hashref handled by the find-another handler above).
      if (link.getAttribute('target') !== '_blank') return;
      try { pausePlay(); } catch (err) { /* noop */ }
    });

    // P2 §D8: mobile dots are real buttons; tap shows that card. Also stops
    // the previously-active card's sound (same contract as the tab bar).
    qa('[data-wsh-dot]').forEach(function (b) {
      b.addEventListener('click', function () {
        var role = b.getAttribute('data-wsh-dot');
        if (!role) return;
        if (ui.playing && String(ui.playing).indexOf('card-') === 0) stopPlay();
        applyTab(role);
      });
    });

    // P2 §D8: swipe on the cards container moves one card. >40 px horizontal
    // and more horizontal than vertical. Vertical scroll never blocked
    // (passive listeners, no preventDefault).
    var cardsEl = q('[data-wsh-cards]');
    if (cardsEl) {
      var sx = 0, sy = 0, dx = 0, dy = 0;
      var SWIPE_MIN = 40;
      cardsEl.addEventListener('touchstart', function (e) {
        var t = e.touches && e.touches[0];
        if (!t) return;
        sx = t.clientX; sy = t.clientY; dx = 0; dy = 0;
      }, { passive: true });
      cardsEl.addEventListener('touchmove', function (e) {
        var t = e.touches && e.touches[0];
        if (!t) return;
        dx = t.clientX - sx;
        dy = t.clientY - sy;
      }, { passive: true });
      cardsEl.addEventListener('touchend', function () {
        if (Math.abs(dx) < SWIPE_MIN) return;
        if (Math.abs(dx) <= Math.abs(dy)) return;
        var roles = ['match', 'next', 'wildcard'];
        var i = roles.indexOf(ui.tab);
        if (i < 0) return;
        var nextI = dx < 0 ? Math.min(roles.length - 1, i + 1) : Math.max(0, i - 1);
        if (nextI === i) return;
        if (ui.playing && String(ui.playing).indexOf('card-') === 0) stopPlay();
        applyTab(roles[nextI]);
      }, { passive: true });
    }

    // Section 1 symptom (b) fix (Phil 2026-10-01 pm): "Edit answers" and
    // "Try another genre" must reach the quiz and STAY there — not auto-
    // bounce back to results because state.step is still 'results' in
    // sessionStorage. Intercept + mutate state via window.__wshFys.jumpToStep
    // instead of letting the anchor navigate.
    document.addEventListener('click', function (e) {
      /* SI §A2 (2026-10-03): three ways out of results close the soundbar
         completely (exactly as its own X does) before the quiz jumps —
         a paused-but-visible soundbar left on screen is not enough. */
      function closeSoundbar() {
        try { if (window.__wshFys && window.__wshFys.closeSoundbar) window.__wshFys.closeSoundbar(); } catch (err) { /* noop */ }
      }
      var edit = e.target.closest && e.target.closest('.wsh-fys-results__edit-link');
      if (edit) {
        e.preventDefault();
        closeSoundbar();
        // P2 §A6: Edit answers opens the GENRE step (new first step) with the
        // previous answers pre-selected. Keep genre/format/use/daw; clear
        // pick/fallback/set_key so the user re-walks the listen step.
        if (window.__wshFys && window.__wshFys.jumpToStep) {
          window.__wshFys.jumpToStep('genre', { pick: null, fallback: null, set_key: null });
        }
        return;
      }
      var tryAnother = e.target.closest && e.target.closest('[data-wsh-try-another]');
      if (tryAnother) {
        e.preventDefault();
        closeSoundbar();
        // "opens the genre step with the genre cleared and the other answers
        // kept." Keep use/format/daw; clear genre/set_key/pick/fallback.
        if (window.__wshFys && window.__wshFys.jumpToStep) {
          window.__wshFys.jumpToStep('genre', { genre: null, set_key: null, pick: null, fallback: null });
        }
        return;
      }
      // Section 2: FIND ANOTHER SOUND on the owned-match card — same behaviour
      // as Try another genre per brief (opens genre step with genre cleared).
      var findAnother = e.target.closest && e.target.closest('[data-wsh-find-another]');
      if (findAnother) {
        e.preventDefault();
        closeSoundbar();
        if (window.__wshFys && window.__wshFys.jumpToStep) {
          window.__wshFys.jumpToStep('genre', { genre: null, set_key: null, pick: null, fallback: null });
        }
        return;
      }
    });
  }

  /* Slice 3: the reminder link names the next and wildcard cards the email
     showed. Each is shown first: picked from the scorer's three when it is one
     of them, otherwise put in front of them. A card is not forced when the
     library is gone from the catalogue, is now owned, or is the match. */
  function applyRebuildCards(rb) {
    var matchH = scoreResult.match && scoreResult.match.handle;
    var ownedList = (owned && owned.owned) || [];
    function shownOf(list, idx) { var o = list && list.options && (list.options[idx] || list.options[0]); return o && o.handle; }
    function place(list, handle, avoid) {
      if (!list || !handle || !data.libraries[handle] || handle === matchH || handle === avoid || ownedList.indexOf(handle) >= 0) return 0;
      var opts = list.options || [];
      for (var i = 0; i < Math.min(opts.length, 3); i++) {
        if (opts[i] && opts[i].handle === handle) return i;
      }
      list.options = [{ handle: handle }].concat(opts.filter(function (o) { return o && o.handle !== handle; })).slice(0, 3);
      return 0;
    }
    ui.nIdx = place(scoreResult.next, rb.next, null);
    var nextShown = shownOf(scoreResult.next, ui.nIdx);
    ui.wIdx = place(scoreResult.wildcard, rb.wildcard, nextShown);
    // The same library never shows in both slots: the wildcard moves on.
    var wl = scoreResult.wildcard && scoreResult.wildcard.options;
    if (wl && shownOf(scoreResult.wildcard, ui.wIdx) === nextShown) {
      for (var j = 0; j < Math.min(wl.length, 3); j++) {
        if (wl[j] && wl[j].handle !== nextShown) { ui.wIdx = j; break; }
      }
    }
  }

  function rerenderTrio() {
    var matchLib = data.libraries[scoreResult.match.handle];
    var nOpt = scoreResult.next.options[ui.nIdx] || scoreResult.next.options[0];
    var wOpt = scoreResult.wildcard.options[ui.wIdx] || scoreResult.wildcard.options[0];
    var nextLib = nOpt && data.libraries[nOpt.handle];
    var wildLib = wOpt && data.libraries[wOpt.handle];
    if (matchLib) renderCard('match', matchLib, matchLib);
    if (nextLib) renderCard('next', nextLib, matchLib);
    if (wildLib) renderCard('wildcard', wildLib, matchLib);
    renderStrip([matchLib, nextLib, wildLib].filter(Boolean));
    updatePlayPills();
    // Slice 2: the cards shown changed. Written after a pause (1.5 s), and only
    // when no other cart change is out; before this page adds or opens a
    // checkout it is written anyway.
    try { __fysClaim.scheduleMark(1500); } catch (e) { /* noop */ }
  }

  var dataLoaded = false;
  function boot() {
    var dataUrl = root.getAttribute('data-fys-data-url');
    var ownedUrl = root.getAttribute('data-fys-owned-url');
    var dataP = fetch(dataUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var ownedP = fetch(ownedUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () {
      return { signed_in: false, owned: [], owned_titles: {} };
    });
    Promise.all([dataP, ownedP]).then(function (arr) {
      data = arr[0];
      owned = arr[1] || { signed_in: false, owned: [], owned_titles: {} };
      dataLoaded = true;
      /* Review fix 1 (2026-10-03): boot() reconciles the intro surfaces
         with the fetched signed_in state once the owned data has loaded.
         Belt-and-braces on top of the server-side `customer` render — a
         stale SSR (e.g., customer signed in via another tab since the
         page was cached) lands at the right surface without waiting for
         the pageshow/visibilitychange re-check. reconcileIntroSurfaces
         is a function declaration below in the IIFE (hoisted). */
      try { reconcileIntroSurfaces(owned); } catch (e) { /* noop */ }
      hydrate();
    }).catch(function (err) {
      console.error('[FYS] data load failed:', err);
    });
  }

  // Section 1 root-cause fix (Phil 2026-10-01 pm): the journey script
  // (wsh-fys.js) completes state writes on the DAW step then calls showResults().
  // We hydrate the results DOM at that moment — not at page-load — so first-
  // arrival renders with the user's REAL answers, not the empty-state defaults.
  // Expose a global so wsh-fys.js can trigger a re-hydrate at any step change.
  window.__wshFysResults = window.__wshFysResults || {};
  window.__wshFysResults.rehydrate = function () {
    if (dataLoaded) { hydrate(); return true; }
    return false; // data still loading; boot's .then() will fire hydrate once.
  };
  // Also listen for an event so there's a decoupled path.
  document.addEventListener('wsh:fys:results:show', function () {
    if (dataLoaded) hydrate();
  });

  function hydrate() {
    var state = (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState()) || {};
    // Section 1 symptom (a) fix: never fall back to 'country' / 'full_band'
    // defaults — if state hasn't been written yet, abort hydrate (the view
    // isn't the results screen anyway; wait for the rehydrate() call).
    if (!state.genre || !state.format) return;
    // P2 Fix §A4 (round 2): reset the "N of 3" positions on every hydrate so
    // Edit answers / Try another genre / Find another sound always land on
    // option 1 of next, wildcard, and guitar (not whatever position the
    // previous session landed on).
    ui.nIdx = 0; ui.wIdx = 0; ui.gIdx = 0;
    var answers = {
      genre: state.genre,
      // Normalize legacy 'full_band' to the UI's 'full'. Section 3: 'both' is
      // retired; map any lingering 'both' to 'full' at hand-off.
      format: (state.format === 'full_band' ? 'full' : (state.format === 'both' ? 'full' : state.format)),
      daw: state.daw || '',
      pick: state.pick || null,
      fallback: state.fallback || null,
      use: state.use || null,
    };
    var catalog = Object.keys(data.libraries).map(function (h) { return data.libraries[h]; });
    // Section 2 (Phil 2026-10-01 pm): the picked library is ALWAYS the match
    // card, even if owned. Owned-exclusion applies ONLY to next, wildcard
    // and guitar. We achieve this by:
    //   (1) passing the full catalog (no pre-filter);
    //   (2) passing an owned list to the scorer that EXCLUDES the picked
    //       handle, so the scorer's own exclusion lets the pick through to
    //       the match slot. Next + wildcard + guitar still exclude the pick
    //       via their own excludeHandles logic (match-slot handle is always
    //       excluded from downstream slots regardless).
    var pickedHandle = (answers.pick && answers.pick.library_handle) || null;
    /* Slice 3: a run reopened from the reminder link shows the three cards
       from the email. A run with no pick (described, or the email held none)
       is scored from the email's match, which the scorer always shows first. */
    var rebuild = null;
    try { rebuild = __fysClaim.rebuildActive(); } catch (e) { rebuild = null; }
    var rebuildAnchor = (rebuild && !pickedHandle && !answers.fallback && rebuild.match && data.libraries[rebuild.match]) ? rebuild.match : null;
    if (rebuildAnchor) pickedHandle = rebuildAnchor;
    var ownedForScorer = (owned.owned || []).filter(function (h) { return h !== pickedHandle; });
    // Bridge fys_config.guitar_parts (metaobject → list) into scoring config
    // key the scorer expects (guitar_parts_handles). Same for wildcard_only.
    var scoringWithGuitar = Object.assign({}, data.scoring, {
      guitar_parts_handles: (data.fys_config && data.fys_config.guitar_parts) || data.scoring.guitar_parts_handles || [],
      wildcard_only_handles: (data.fys_config && data.fys_config.wildcard_only) || data.scoring.wildcard_only_handles || [],
    });
    // P2 Fix §A3 (round 2): the scorer's FALLBACK_ANCHOR_MAP keys energy on
    // 'laid-back' | 'steady' | 'driving'; the quiz saves 'laid' | 'steady' |
    // 'driving'. Map at the hand-off so the scorer sees the right key — do
    // NOT edit the scorer (its harness stays 66/66). Only translate for the
    // scorer input; chip labels + bar values keep the quiz keys.
    var answersForScorer = answers;
    if (answers.fallback && answers.fallback.energy === 'laid') {
      answersForScorer = Object.assign({}, answers, {
        fallback: Object.assign({}, answers.fallback, { energy: 'laid-back' }),
      });
    }
    if (rebuildAnchor) answersForScorer = Object.assign({}, answersForScorer, { pick: { library_handle: rebuildAnchor } });
    scoreResult = window.fysScore({
      answers: answersForScorer,
      catalog: catalog,
      config: scoringWithGuitar,
      owned: ownedForScorer,
    });
    /* Cart slice (Phil, 7 Oct 21:26): the guitar card leaves out libraries the
       buyer owns, and is hidden when all it could suggest are owned. The scorer
       is frozen, so the filter runs here, after scoring. */
    if (scoreResult && scoreResult.guitar_layer && scoreResult.guitar_layer.options) {
      var ownedSet = {};
      (owned.owned || []).forEach(function (h) { ownedSet[h] = true; });
      var gKeep = scoreResult.guitar_layer.options.filter(function (o) { return o && !ownedSet[o.handle]; });
      scoreResult.guitar_layer = gKeep.length ? Object.assign({}, scoreResult.guitar_layer, { options: gKeep }) : null;
    }
    if (rebuild && scoreResult && scoreResult.match) applyRebuildCards(rebuild);
    renderSignRow();
    renderHeadChips(answers);
    var anchorLib = null;
    if (answers.pick && answers.pick.library_handle) anchorLib = data.libraries[answers.pick.library_handle];
    if (!anchorLib && scoreResult && scoreResult.match) anchorLib = data.libraries[scoreResult.match.handle];
    if (rebuild && !answers.pick && !answers.fallback) {
      // How this run's sound was chosen isn't known here: no "picked by ear" panel.
      var pp = q('[data-wsh-picked-panel]'); if (pp) pp.hidden = true;
    } else {
      renderPicked(answers, anchorLib);
    }
    if (scoreResult && scoreResult.match) rerenderTrio();
    // Section 1 symptom (c) fix: accept 'full' (what wsh-fys.js writes) + the
    // legacy 'full_band' alias. 'both' maps to 'full' upstream now (Section 3).
    if (answers.format === 'full' || answers.format === 'full_band' || answers.format === 'both') renderGuitarCard();
    else { var gu = q('[data-wsh-guitar]'); if (gu) gu.hidden = true; }
    renderClaim(answers);
    renderFooter(answers);
    // Slice 2: mark the cart with this run (claimed visitors included).
    try { __fysClaim.scheduleMark(); } catch (e) { /* noop */ }
    applyTab('match');
    // P2 §D1: wireEvents + installSoundbarPresentation run ONCE per page load.
    // hydrate() may run many times (initial boot, every rehydrate from Edit
    // answers / Try another genre / Find another sound) — only re-renders.
    if (!wiredOnce) { wireEvents(); wiredOnce = true; }
    if (!soundbarInstalled) { installSoundbarPresentation(); soundbarInstalled = true; }
  }
  var wiredOnce = false;
  var soundbarInstalled = false;

  // S4 — soundbar presentation on FYS results.
  // (1) Bar is hidden until first play by the soundbar snippet's own CSS; no code
  // required here. (2) Measure soundbar height on play and expose it as a CSS var
  // (--wsh-fys-soundbar-h) + body class (wsh-fys-soundbar-visible). CSS in
  // wsh-fys-results.css pads the results section's bottom accordingly. (3) Cart
  // drawer: no code — the native <dialog> top-layer overlays the bar automatically.
  // (4) Mobile: when a FYS input is focused, hide the bar until blur so it never
  // sits above the keyboard-raised input.
  function installSoundbarPresentation() {
    var body = document.body;
    function measure() {
      var sb = document.querySelector('wsh-soundbar .soundbar');
      if (!sb) return 0;
      var r = sb.getBoundingClientRect();
      return Math.max(0, Math.round(r.height));
    }
    function setOffset() {
      var h = measure();
      document.documentElement.style.setProperty('--wsh-fys-soundbar-h', h + 'px');
      body.classList.toggle('wsh-fys-soundbar-visible', h > 0);
    }
    function clearOffset() {
      document.documentElement.style.setProperty('--wsh-fys-soundbar-h', '0px');
      body.classList.remove('wsh-fys-soundbar-visible');
    }
    // P2 Fix §B10 (round 2): the soundbar's own product link
    // (a.soundbar__link) is rendered by the app extension and opens in the
    // same tab by default. Theme-side, we flip its target + rel every time
    // the track changes, and pause the sound when it's clicked — same
    // contract as the three card CTAs + the two guitar CTAs.
    function markSoundbarLink() {
      var link = document.querySelector('wsh-soundbar a.soundbar__link');
      if (!link) return;
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    }
    document.addEventListener('wsh:audio:play', function () { setOffset(); markSoundbarLink(); });
    document.addEventListener('wsh:audio:track-change', function () { setOffset(); markSoundbarLink(); });
    // Delegated click handler — pauses the results sound before the new tab opens.
    document.addEventListener('click', function (e) {
      var sbLink = e.target.closest && e.target.closest('wsh-soundbar a.soundbar__link');
      if (!sbLink) return;
      try { pausePlay(); } catch (err) { /* noop */ }
    });
    document.addEventListener('wsh:audio:pause', function () {
      // Bar stays visible after pause (soundbar snippet keeps it mounted); only
      // the close button or page nav fully retracts. Keep the pad in place so
      // the layout doesn't jump on every pause.
      setOffset();
    });
    // Observe the soundbar for class changes so when the user hits the close
    // button on the bar (removes .active) we drop the offset.
    var sbEl = document.querySelector('wsh-soundbar');
    if (sbEl && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        var active = sbEl.querySelector('.soundbar.active');
        if (active) setOffset(); else clearOffset();
      }).observe(sbEl, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
    // Mobile input focus: hide the bar for the duration of focus so it never
    // overlaps the keyboard-raised input in the claim block.
    var claim = q('[data-wsh-claim]');
    if (claim) {
      claim.addEventListener('focusin', function (e) {
        if (window.innerWidth > 749) return;
        var tag = e.target && e.target.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') body.classList.add('wsh-fys-input-focused');
      });
      claim.addEventListener('focusout', function () {
        body.classList.remove('wsh-fys-input-focused');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── SI §C3 (2026-10-03) · follow the real signed-in state ──────────────
     On pageshow (incl. bfcache restore) and whenever the tab becomes
     visible again, re-fetch the owned-libraries endpoint and compare to
     what is on screen.
       • If signed_in or the owned list differs:
           - On the results page, pause all sound and re-render via
             hydrate(). renderSignRow() applies C5 for the "nothing to
             leave out" case; the three cards, bundle strip, guitar
             card and claim block all re-run.
           - On the Start page, swap the signed-in / signed-out surfaces
             (both rendered in the intro — see wsh-fys-intro.liquid).
       • If nothing changed, do nothing. No flicker, no reset of "N of 3"
         (ui.nIdx/wIdx/gIdx are only reset inside hydrate), a playing
         soundbar keeps playing.
     Throttle: at most once every 5 seconds (brief). Clock is Date.now()
     (browser clock, per Phil's addition 2). Fetch sends cache:'no-store'
     belt-and-braces — the endpoint already carries cache-control:
     private, max-age=0, must-revalidate (Phase 0 item 4). */
  var lastOwnedCheck = 0;
  var OWNED_RECHECK_MIN_MS = 5000;
  function sameOwnedShape(a, b) {
    if (!a || !b) return false;
    if (!!a.signed_in !== !!b.signed_in) return false;
    // FYS-3B-1b: a claim made since the last check, or a different account,
    // is a change too.
    if ((a.claimed === true) !== (b.claimed === true)) return false;
    if (String(a.customer_email || '') !== String(b.customer_email || '')) return false;
    var ax = (a.owned || []).slice().sort().join('|');
    var bx = (b.owned || []).slice().sort().join('|');
    return ax === bx;
  }
  function reconcileIntroSurfaces(o) {
    try {
      var isSignedIn = !!(o && o.signed_in);
      var hasClaimed = isSignedIn && o.claimed === true;
      var inView = document.querySelector('[data-wsh-signed-in-view]');
      var outView = document.querySelector('[data-wsh-signed-out-view]');
      if (inView) inView.hidden = !isSignedIn;
      if (outView) outView.hidden = !!isSignedIn;
      // FYS-3B-1b: the note under the button is for guests; the third box
      // (the sessions offer) is for everyone who has not claimed.
      var i, guestOnly = document.querySelectorAll('[data-wsh-fys-guest-only]');
      for (i = 0; i < guestOnly.length; i++) guestOnly[i].hidden = isSignedIn;
      // The quiz's side panel carries a line about the sessions on every step
      // (snippets/wsh-fys-profile.liquid): it is part of the offer too.
      var offer = document.querySelectorAll('[data-wsh-fys-offer], [data-wsh-profile-note]');
      for (i = 0; i < offer.length; i++) offer[i].hidden = hasClaimed;
    } catch (e) { /* noop */ }
  }
  function recheckOwned() {
    if (!root) return;
    var now = Date.now();
    if (now - lastOwnedCheck < OWNED_RECHECK_MIN_MS) return;
    lastOwnedCheck = now;
    var url = root.getAttribute('data-fys-owned-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (fresh) {
        if (!fresh) return;
        var ownedNow = owned || { signed_in: false, owned: [], owned_titles: {} };
        if (sameOwnedShape(ownedNow, fresh)) return; // nothing changed — zero DOM work
        // Something changed: stop the sound, swap intro surfaces, re-hydrate results.
        try { pausePlay(); } catch (e) { /* noop */ }
        owned = fresh;
        reconcileIntroSurfaces(fresh);
        try { if (dataLoaded) hydrate(); } catch (e) { /* noop */ }
      })
      .catch(function () {
        // FYS-3B-1b: a failed check must not hold the next one back for the
        // full 5 s, or a stale "Signed in as" could stay on screen after a
        // sign-out. One second, so a lookup that keeps failing is not hammered.
        lastOwnedCheck = Date.now() - OWNED_RECHECK_MIN_MS + 1000;
      });
  }
  window.addEventListener('pageshow', recheckOwned);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recheckOwned();
  });

  /* ──────────────────────────────────────────────────────────────────────────
     FYS-3B-1a — the guest claim, slice 1a.
     §B  Run id + fingerprint + storage       (B2)
     §B  Entry normalisation + stickiness     (B3)
     §B  Submit → validate → waiting → fetch → outcome
     §B  Checkout URL build (encodeURIComponent on every part)
     §B  Pageshow back-from-checkout handling (B6)
     §B  Run-change reset                     (B7)
     §C  Four events (seen, press, checkout, already) via window.__wshFys.fysTrack
     Public: window.__wshFysResults.getRun() returns the current run id.
     ────────────────────────────────────────────────────────────────────────── */

  var CLAIM_SERVER_URL = 'https://cms.wesoundhuman.com/wsh/fys/claim-start';
  var CLAIM_TIMEOUT_MS = 2500;
  var CHECKOUT_SETTLE_MS = 10000;
  /* Cart slice (Phil, 8 Oct): "pay first, sessions after". The claim link
     replaces the cart, so a visitor whose cart holds libraries is never sent
     to it. They are told their sessions are saved and sent to their own
     checkout; the claim follows once they have paid. */
  var AUDITION_HANDLE = 'audition-sessions';
  var HELD_RETURN_MS = 30 * 60 * 1000;   // same window as the sign-in return ticket in wsh-fys.js
  /* Slice 3 (Phil, 9-10 Oct): visitors who come from one of our emails.
     Klaviyo adds _kx (the email-link token) to every link in our emails. The
     page keeps it for this visit only (sessionStorage), never sends or shows
     an address for it, and hands it to two server routes (FYS-3C):
       link-run   saves the run to the token's profile, once per run, a few
                  seconds after the results show (no press needed);
       link-claim is the press with nothing to type; it answers with the
                  claim link the server built.
     Signed in with a usable account email beats the token: the account is
     used, as in slice 1b, and the token is not used at all. */
  var LINK_RUN_URL = 'https://cms.wesoundhuman.com/wsh/fys/link-run';
  var LINK_CLAIM_URL = 'https://cms.wesoundhuman.com/wsh/fys/link-claim';
  var LINK_SAVE_DELAY_MS = 4000;          // results showing this long before the save
  var LINK_SAVE_RETRY_MS = 5000;          // one more try after a network failure
  var LINK_SAVE_WAIT_MS = 3000;           // a press is out: look again after this
  var KX_STRIP_MAX_MS = 10000;            // _kx leaves the address bar by then at the latest
  var KX_RE = /^[A-Za-z0-9_-]{8,256}\.[A-Za-z0-9]{3,20}$/;   // the server's own format check
  var KX_KEY = 'wsh_fys_kx';
  var RUN_RE = /^[a-z0-9]{16}$/;

  /* B3 — normalise an entry value: lower-case, non-[a-z0-9_-] → '-',
     collapse leading/trailing '-', cut to 24, default 'direct'. */
  function fysNormalizeEntry(raw) {
    var s = String(raw == null ? '' : raw).toLowerCase();
    s = s.replace(/[^a-z0-9_\-]/g, '-');
    s = s.replace(/^-+|-+$/g, '');
    s = s.slice(0, 24);
    return s || 'direct';
  }

  /* §2 server map — genre: six canonical labels; 'Jazz & Blues' → 'Jazz';
     anything else returns null (field is left out of the body). */
  var FYS_GENRE_SERVER = {
    'Country': 'Country', 'Rock': 'Rock', 'Jazz & Blues': 'Jazz',
    'Indie': 'Indie', 'Cinematic': 'Cinematic', 'Pop': 'Pop'
  };
  function fysGenreForServer(g) { return FYS_GENRE_SERVER[g] || null; }
  function fysFormatForServer(f) {
    if (f === 'drums') return 'Drums Only';
    if (f === 'full' || f === 'both' || f === 'full_band') return 'Full Band';
    return null;
  }

  /* Audition Sessions slice (Phil, 10 Oct): the claim offers the visitor's
     own genre and format set (data.audition_sets, one per Audition Sessions
     variant). Returns { variant_id, kits, genre, format, isSet } or null.
     Falls back to the Sampler for the format when no set matches, so the
     block never disappears because one set is missing. */
  function fysValidVariant(v) {
    return (typeof v === 'number') && (v > 0) && Number.isInteger(v);
  }
  /* The quiz's genre label for any spelling the page may hold: the label
     itself ("Jazz & Blues"), an older saved key ("jazz-blues") or the
     event spelling ("Jazz"), any case, spaces trimmed. */
  var FYS_GENRE_LABEL = {
    'country': 'Country', 'rock': 'Rock', 'jazz & blues': 'Jazz & Blues', 'jazz-blues': 'Jazz & Blues',
    'jazz': 'Jazz & Blues', 'indie': 'Indie', 'cinematic': 'Cinematic', 'pop': 'Pop'
  };
  function fysGenreLabel(g) {
    if (!g || typeof g !== 'string') return null;
    return FYS_GENRE_LABEL[g.replace(/^\s+|\s+$/g, '').toLowerCase()] || null;
  }
  function fysSameText(a, b) {
    return typeof a === 'string' && typeof b === 'string' &&
      a.replace(/^\s+|\s+$/g, '').toLowerCase() === b.replace(/^\s+|\s+$/g, '').toLowerCase();
  }
  function claimSetFor(s) {
    if (!s || !data) return null;
    var fmt = fysFormatForServer(s.format);
    var sets = data.audition_sets;
    var g = fysGenreLabel(s.genre);
    if (fmt && g && sets && sets.length) {
      for (var i = 0; i < sets.length; i++) {
        var st = sets[i];
        if (st && fysSameText(st.genre, g) && fysSameText(st.format, fmt) && fysValidVariant(st.variant_id) && st.kits && st.kits.length) {
          return { variant_id: st.variant_id, kits: st.kits, genre: g, format: fmt, isSet: true };
        }
      }
    }
    var sk = data.sampler_kits;
    if (!sk) return null;
    var samp = (s.format === 'drums') ? sk.drums_only : sk.full_band;
    if (!samp) return null;
    return { variant_id: samp.variant_id, kits: samp.kits || [], genre: '', format: '', isSet: false };
  }
  /* Every Audition Sessions variant the page knows (the sets and the
     Sampler): a cart line with one of these is the claim's, not a library. */
  function auditionVariantIds() {
    var ids = [];
    var sk = data && data.sampler_kits;
    if (sk) {
      if (sk.full_band && sk.full_band.variant_id) ids.push(sk.full_band.variant_id);
      if (sk.drums_only && sk.drums_only.variant_id) ids.push(sk.drums_only.variant_id);
    }
    var sets = data && data.audition_sets;
    if (sets && sets.length) {
      for (var i = 0; i < sets.length; i++) {
        if (sets[i] && sets[i].variant_id) ids.push(sets[i].variant_id);
      }
    }
    return ids;
  }
  var FYS_VALID_DAWS = ['Logic Pro', 'Ableton', 'Pro Tools', 'Cubase', 'Studio One', 'GarageBand', 'Reaper', 'FL Studio', 'Other'];
  function fysDawForServer(d) {
    if (!d) return null;
    for (var i = 0; i < FYS_VALID_DAWS.length; i++) {
      if (FYS_VALID_DAWS[i] === d) return d;
    }
    return null;
  }
  var FYS_CREATING_MAP = { songs: 'Songs', tracks: 'Tracks', picture: 'Picture', exploring: 'Exploring' };
  function fysCreatingForServer(u) { return (u && FYS_CREATING_MAP[u]) || null; }

  var __fysClaim = (function () {
    var inMemoryRun = null;        // storage-blocked fallback for the run row
    var inMemoryEntry = null;      // storage-blocked fallback for the sticky entry
    var callSeq = 0;               // one number per call; a cancelled or replaced call is ignored when it answers
    var lastRenderedRunId = null;  // B7 run-change detection across renders
    var lastWho = null;            // 1b: who the block was last rendered for ('guest' or 'account:<email>')
    var waitingAbort = null;       // AbortController while a call is in flight
    var waitingRunId = null;       // run id associated with the pending call
    var checkoutSettleTimer = null; // B5 last line — return-to-guest after 10s
    var cartLibs = null;           // cart slice: library lines in the cart at the last read; null = not known
    var cartReadAt = 0;
    var cartReadSeq = 0;           // cart slice: a read that is not the newest is ignored
    var cartOkSeq = 0;             // cart slice: number of the newest read that succeeded

    /* B2 fingerprint — the single string that keys the current run.
       Keys: genre, format, DAW, creating (use), picked library handle (or the
       two describe-it answers), the saved note. A reload / SHOW ME ANOTHER /
       second press / coming back / owned-libraries re-check all leave this
       string unchanged; Edit answers / Try another genre / Start again
       change it. */
    function fpOfState(s) {
      s = s || {};
      var picked = (s.pick && s.pick.library_handle) || '';
      var fbE = (s.fallback && s.fallback.energy) || '';
      var fbF = (s.fallback && s.fallback.feel) || '';
      return [
        s.genre || '',
        s.format || '',
        s.daw || '',
        s.use || '',
        picked,
        fbE,
        fbF,
        s.note || ''
      ].join('|');
    }

    /* B2 — 16 chars, letters + digits only, from crypto.getRandomValues. */
    function newRunId() {
      var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
      try {
        var buf = new Uint8Array(16);
        crypto.getRandomValues(buf);
        var out = '';
        for (var i = 0; i < 16; i++) out += alphabet.charAt(buf[i] % 36);
        return out;
      } catch (e) {
        // Fallback — Math.random is still 16 letters+digits, run id uniqueness
        // is for correlating one visitor's events, not cryptographic.
        var s = '';
        while (s.length < 16) s += Math.random().toString(36).replace(/[^a-z0-9]/g, '');
        return s.slice(0, 16);
      }
    }

    function readRow() {
      try {
        var raw = sessionStorage.getItem('wsh_fys_run');
        if (raw) return JSON.parse(raw);
      } catch (e) { /* storage blocked / parse error */ }
      return inMemoryRun;
    }
    function writeRow(obj) {
      try { sessionStorage.setItem('wsh_fys_run', JSON.stringify(obj)); } catch (e) { /* noop */ }
      inMemoryRun = obj;
    }
    function clearRow() {
      try { sessionStorage.removeItem('wsh_fys_run'); } catch (e) { /* noop */ }
      inMemoryRun = null;
      lastRenderedRunId = null;
    }

    function currentState() {
      return (window.__wshFys && window.__wshFys.getState && window.__wshFys.getState()) || {};
    }

    /* Cart slice: a visitor who was told "Your sessions are saved" and comes
       back in another tab within the return window keeps the same run, so the
       server sees one run, not two. */
    function readHeldRun() {
      try {
        var raw = localStorage.getItem('wsh_fys_held_run');
        if (!raw) return null;
        var h = JSON.parse(raw);
        if (!h || !h.id || typeof h.saved_at !== 'number') return null;
        if (Date.now() - h.saved_at > HELD_RETURN_MS) { clearHeldRun(); return null; }
        return h;
      } catch (e) { return null; }
    }
    /* withTicket: the claim went ahead (claim link or already claimed), so the
       answers saved for another tab by a held press go too. */
    function clearHeldRun(withTicket) {
      var had = false;
      try { had = !!localStorage.getItem('wsh_fys_held_run'); localStorage.removeItem('wsh_fys_held_run'); } catch (e) { /* noop */ }
      if (had && withTicket) { try { localStorage.removeItem('wsh_fys_return'); } catch (e) { /* noop */ } }
    }
    /* Slice 3: the 30-minute reminder link reopens a run (wsh-fys.js puts it
       in state.rebuild: run id and the three cards from the email). The run
       keeps its id, so the server's events stay one per run. It holds while
       the answers are the ones it opened with; Edit answers, Try another
       genre or Start again end it. */
    function rebuildState() {
      var s = currentState();
      var rb = s && s.rebuild;
      if (!rb || typeof rb !== 'object' || !RUN_RE.test(String(rb.run || ''))) return null;
      return rb;
    }
    /* For the answers on screen now (the first call records them). */
    function rebuildActive() {
      return rebuildFor(fpOfState(currentState()));
    }
    /* A stored row for these answers that is not the reopened run gives way to it. */
    function rebuildWants(row, fp) {
      var rb = rebuildState();
      if (!rb || row.id === rb.run) return false;
      return !rb.fp || rb.fp === fp;
    }
    function rebuildFor(fp) {
      var rb = rebuildState();
      if (!rb) return null;
      if (rb.fp && rb.fp !== fp) return null;
      if (!rb.fp) {
        rb.fp = fp;   // the answers it opened with
        try { if (window.__wshFys && window.__wshFys.saveState) window.__wshFys.saveState(); } catch (e) { /* noop */ }
      }
      return rb;
    }
    function newRow(fp) {
      // A reopened run was saved when it was first made: no link save again.
      var rb = rebuildFor(fp);
      if (rb) return { id: rb.run, fp: fp, linkSaved: true };
      var h = readHeldRun();
      if (h && h.fp === fp) { var r = { id: h.id, fp: fp }; if (h.seen) r.seen = true; if (h.at) r.at = h.at; return r; }
      return { id: newRunId(), fp: fp };
    }

    function ensureRun() {
      var fp = fpOfState(currentState());
      var existing = readRow();
      if (existing && existing.fp === fp && existing.id && !rebuildWants(existing, fp)) return existing;
      var fresh = newRow(fp);
      writeRow(fresh);
      return fresh;
    }

    function readEntry() {
      // B3 — the first entry value that is not 'direct' is remembered in
      // sessionStorage and used whenever the state gives 'direct'. Start again
      // clears state.from (in wsh-fys.js); the remembered value survives it.
      var sticky;
      try { sticky = sessionStorage.getItem('wsh_fys_entry') || null; } catch (e) { sticky = null; }
      if (!sticky && inMemoryEntry) sticky = inMemoryEntry;
      var raw = (currentState().from && String(currentState().from)) || '';
      var normalized = fysNormalizeEntry(raw);
      if (normalized !== 'direct') {
        if (!sticky) {
          try { sessionStorage.setItem('wsh_fys_entry', normalized); } catch (e) { /* noop */ }
          inMemoryEntry = normalized;
        }
        return normalized;
      }
      return sticky || 'direct';
    }

    /* Slice 3 — the email-link token, this visit only (Phil, 10 Oct: A).
       Stored as { kx, off }. off: the visitor said "Not you?", or the server
       could not use it; it stays off for this token for the rest of the visit.
       A different token (a new email click) starts fresh. */
    var kxMem = null;
    function readKxRec() {
      try {
        var raw = sessionStorage.getItem(KX_KEY);
        if (raw) {
          var o = JSON.parse(raw);
          if (o && typeof o.kx === 'string') return o;
        }
      } catch (e) { /* storage blocked / parse error */ }
      return kxMem;
    }
    function writeKxRec(o) {
      kxMem = o;
      try { sessionStorage.setItem(KX_KEY, JSON.stringify(o)); } catch (e) { /* noop */ }
    }
    function kxInAddress() {
      try { return new URLSearchParams(window.location.search).get('_kx'); } catch (e) { return null; }
    }
    function captureKx() {
      var v = kxInAddress();
      if (v == null || !KX_RE.test(v)) return;
      var have = readKxRec();
      if (have && have.kx === v) return;   // the same token: keep what we know about it
      writeKxRec({ kx: v, off: false });
    }
    function heldKx() {
      var r = readKxRec();
      return (r && !r.off && KX_RE.test(r.kx)) ? r.kx : '';
    }
    function dropKx() {
      var r = readKxRec();
      writeKxRec({ kx: (r && r.kx) || '', off: true });
      if (linkSaveTimer) { clearTimeout(linkSaveTimer); linkSaveTimer = null; }
    }
    /* Known only by the token: not signed in with a usable account email. */
    function linkMode() { return !accountEmail() && !!heldKx(); }

    /* The token leaves the address bar once Klaviyo's own script has read it
       (it identifies the visitor from it; removing it sooner would break
       Klaviyo's browse tracking for this visit), and after 10 s at the latest.
       Then a copied or shared page address no longer carries it. */
    function stripKxFromAddress() {
      try {
        var u = new URL(window.location.href);
        if (!u.searchParams.has('_kx')) return;
        u.searchParams.delete('_kx');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) { /* noop */ }
    }
    function stripKxWhenKlaviyoHasIt() {
      if (kxInAddress() == null) return;
      var done = false;
      function go() { if (done) return; done = true; clearTimeout(cap); stripKxFromAddress(); }
      var cap = setTimeout(go, KX_STRIP_MAX_MS);
      var tries = 0;
      (function wait() {
        if (done) return;
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          var p = null;
          try { p = k.isIdentified(); } catch (e) { p = null; }
          if (p && typeof p.then === 'function') {
            p.then(function () { setTimeout(go, 300); }, function () { setTimeout(go, 300); });
          } else {
            setTimeout(go, 300);
          }
          return;
        }
        if (++tries < 40) setTimeout(wait, 250);
      })();
    }

    /* Form-element lookups. Scoped to the results root in case of multiple
       sections on a page (defensive). */
    function formEl() { return root && root.querySelector('[data-wsh-claim-form]'); }
    function fieldEl() { return root && root.querySelector('[data-wsh-claim-email]'); }
    function submitEl() { return root && root.querySelector('[data-wsh-claim-submit]'); }
    function errorEl() { return root && root.querySelector('[data-wsh-claim-error]'); }
    function fieldsEl() { return root && root.querySelector('[data-wsh-claim-fields]'); }
    function alreadyEl() { return root && root.querySelector('[data-wsh-claim-already]'); }
    function alreadyTitleEl() { return root && root.querySelector('[data-wsh-claim-already-title]'); }
    function trapEl() { return root && root.querySelector('[data-wsh-claim-trap]'); }
    function hostEl() { return root && root.querySelector('[data-wsh-claim]'); }
    function emailLabelEl() { return root && root.querySelector('[data-wsh-claim-email-label]'); }
    function accountLabelEl() { return root && root.querySelector('[data-wsh-claim-account-label]'); }
    function accountEl() { return root && root.querySelector('[data-wsh-claim-account]'); }
    function heldEl() { return root && root.querySelector('[data-wsh-claim-held]'); }
    function heldTitleEl() { return root && root.querySelector('[data-wsh-claim-held-title]'); }
    function tailEl() { return root && root.querySelector('[data-wsh-claim-tail]'); }
    function linkNoteEl() { return root && root.querySelector('[data-wsh-claim-link-note]'); }
    function notYouEl() { return root && root.querySelector('[data-wsh-claim-not-you]'); }
    function consentEl() { return root && root.querySelector('[data-wsh-claim-consent]'); }
    function isHeld() { var h = heldEl(); return !!(h && !h.hidden); }

    /* Cart slice — the cart. A library line is any line that is not the
       Audition Sessions product (by handle, and by every Audition Sessions
       variant id the page knows: the twelve sets and the Sampler). */
    function samplerVariantIds() { return auditionVariantIds(); }
    function countLibraries(cart) {
      var items = (cart && cart.items) || [];
      var ids = samplerVariantIds();
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it) continue;
        if (it.handle === AUDITION_HANDLE) continue;
        if (ids.indexOf(it.variant_id) >= 0) continue;
        n++;
      }
      return n;
    }
    /* Resolves to the number of library lines, or null when the cart could
       not be read in time. Never rejects. */
    function readCart(timeoutMs) {
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var done = false;
      var mySeq = ++cartReadSeq;
      return new Promise(function (resolve) {
        var timer = setTimeout(function () {
          if (done) return;
          done = true;
          if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } }
          resolve(null);
        }, timeoutMs || CLAIM_TIMEOUT_MS);
        var opts = { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
        if (ctrl) opts.signal = ctrl.signal;
        fetch('/cart.js', opts).then(function (r) {
          if (!r.ok) throw new Error('cart ' + r.status);
          return r.json();
        }).then(function (cart) {
          if (done) return;
          done = true; clearTimeout(timer);
          var n = countLibraries(cart);
          // An older read that lands after a newer one must not overwrite it.
          if (mySeq > cartOkSeq) { cartOkSeq = mySeq; cartLibs = n; cartReadAt = Date.now(); }
          resolve(n);
        }, function () {
          if (done) return;
          done = true; clearTimeout(timer);
          resolve(null);
        });
      });
    }
    /* Follow-up (Phil, 8 Oct): a Sampler left in the cart by a claim that was
       not finished (the visitor opened the $0 checkout, came back and shops)
       would be charged at full price next to a bundle discount, because the
       Sampler code and the bundle discounts do not combine. Before this page
       adds libraries, it takes out any Sampler line and the claim's fys_ cart
       attributes. Never rejects; a failure here never stops the add. */
    /* A promise that settles within ms: the value, or `fallback` if it is late.
       (The request itself is not cancelled.) */
    function withLimit(p, ms, fallback) {
      return new Promise(function (resolve) {
        var done = false;
        var t = setTimeout(function () { if (!done) { done = true; resolve(fallback); } }, ms);
        p.then(function (v) { if (!done) { done = true; clearTimeout(t); resolve(v); } },
               function () { if (!done) { done = true; clearTimeout(t); resolve(fallback); } });
      });
    }
    var lastItemCount = null;     // item count from the last removal, for the cart icon
    /* Exactly the attributes the claim link sets (buildCheckoutUrl); any other
       fys_ attribute a later slice adds is left alone. */
    /* FYS-4H item 1 (2026-10-17): fys_src rides on the claim alongside the twelve
       existing attributes. First-sticky entry-tag from sessionStorage.wsh_fys_src
       (populated by wsh-fys.js's ?src= first-touch). Visible attribute, same naming
       convention. ?src= is only the entry tag; ?from= is the exit return address;
       never mix. */
    var CLAIM_LINK_ATTRS = ['fys_run', 'fys_entry', 'fys_at', 'fys_genre', 'fys_format', 'fys_daw', 'fys_creating', 'fys_pick', 'fys_match', 'fys_next', 'fys_wildcard', 'fys_note', 'fys_src'];

    /* Slice 2 (Phil, 9 Oct): every cart carries the run on screen, so a paid
       order that began on Find Your Sound is marked by the server (fys_origin,
       answers to the profile, one Completed event). The cart is marked as soon
       as the results show and again whenever the run or the three cards shown
       change, so every add carries it, the soundbar's included. Same twelve
       keys and values as the claim link; a key with no value is sent empty, so
       nothing from an earlier run stays. fys_at is when the results of this
       run were first shown. */
    /* When this run's results were first shown (whole seconds), kept on the run
       row. The claim link and the cart marking both send it as fys_at. */
    function runAt() {
      var row = ensureRun();
      if (!row) return Math.floor(Date.now() / 1000);
      var nowSec = Math.floor(Date.now() / 1000);
      // A tab kept open (or restored) for more than a day: the run counts from now.
      if (!row.at || nowSec - row.at > 86400) { row.at = nowSec; writeRow(row); }
      return row.at;
    }
    function markingAttrs() {
      if (!resultsShowing() || !scoreResult || !data) return null;
      var row = ensureRun();
      if (!row || !row.id) return null;
      var at = runAt();
      var b = buildBody('');
      var v = {
        fys_run: b.run, fys_entry: b.entry, fys_at: String(at), fys_genre: b.genre, fys_format: b.format,
        fys_daw: b.daw, fys_creating: b.creating, fys_pick: b.pick, fys_match: b.match, fys_next: b.next,
        fys_wildcard: b.wildcard, fys_note: b.note, fys_src: b.src
      };
      var out = {};
      CLAIM_LINK_ATTRS.forEach(function (k) { out[k] = (v[k] == null) ? '' : String(v[k]); });
      return out;
    }
    function normAttr(v) { return (v == null) ? '' : String(v).replace(/\r\n?/g, '\n').replace(/^\s+|\s+$/g, ''); }
    function attrsDiffer(have, want) {
      have = have || {};
      for (var i = 0; i < CLAIM_LINK_ATTRS.length; i++) {
        var k = CLAIM_LINK_ATTRS[i];
        if (normAttr(have[k]) !== normAttr(want[k])) return true;
      }
      return false;
    }
    /* Slice 2 fix (Phil, 9 Oct): Shopify can lose one of two cart changes sent
       at the same time (seen on staging: a marking write during an outside
       add wiped the add). So the page watches every cart change on the page,
       whatever sends it (the soundbar, the cart drawer, this script), by
       counting /cart/add, /cart/change, /cart/update and /cart/clear requests
       made with fetch or XMLHttpRequest. It only counts; every request goes
       through untouched. The marking write waits until no change is out and
       the last one ended a moment ago. */
    var cartWatch = window.__wshFysCartWatch || (window.__wshFysCartWatch = { open: {}, nextId: 1, lastEnd: 0, installed: false, ours: null, rawFetch: null });
    var CART_QUIET_MS = 800;
    var CART_STUCK_MS = 20000;
    function isCartChange(url, method) {
      if (!url) return false;
      if (String(method || 'GET').toUpperCase() === 'GET') return false;
      var path = String(url);
      try { path = new URL(path, window.location.href).pathname; } catch (e) { /* keep as is */ }
      return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(path);
    }
    // One entry per outside cart change that is out, each with its own start time.
    function cartChangeStarted() { var id = cartWatch.nextId++; cartWatch.open[id] = Date.now(); return id; }
    function cartChangeEnded(id) { if (cartWatch.open[id]) { delete cartWatch.open[id]; cartWatch.lastEnd = Date.now(); } }
    function cartBusyCount() {
      var n = 0, now = Date.now();
      for (var k in cartWatch.open) {
        if (!Object.prototype.hasOwnProperty.call(cartWatch.open, k)) continue;
        // A change that has not ended after 20 s is no longer waited for.
        if (now - cartWatch.open[k] > CART_STUCK_MS) { delete cartWatch.open[k]; cartWatch.lastEnd = now; continue; }
        n++;
      }
      return n;
    }
    function cartQuiet() { return cartBusyCount() === 0 && (Date.now() - cartWatch.lastEnd) > CART_QUIET_MS; }
    /* This page's own cart writes go through ourCartFetch: they bypass the
       watcher, and while one is out, an outside cart change sent with fetch
       waits for it to end (at most 4 s) before it is sent. Its caller still
       gets the same answer, only a moment later. An XMLHttpRequest cannot be
       held; it is counted, and this page waits for it. */
    function ourCartFetch(url, opts) {
      // Sent through window.fetch so any other script watching fetch still sees
      // it; the flag tells this page's wrapper to let it through as is.
      var p;
      cartWatch.selfCall = !!cartWatch.installed;
      try { p = window.fetch(url, opts); } finally { cartWatch.selfCall = false; }
      var mine = p.then(function () {}, function () {});
      var prev = cartWatch.ours;
      cartWatch.ours = prev ? Promise.all([prev, mine]).then(function () {}) : mine;
      var current = cartWatch.ours;
      // (The quiet pause is for outside changes; this page's own writes are already one at a time.)
      current.then(function () { if (cartWatch.ours === current) cartWatch.ours = null; });
      return p;
    }
    /* Resolves once no outside cart change is out and the last ended a moment
       ago, or after maxMs, whichever comes first. Never rejects. */
    function waitCartQuiet(maxMs) {
      var t0 = Date.now();
      return new Promise(function (resolve) {
        (function check() {
          if (cartQuiet() || Date.now() - t0 >= maxMs) return resolve();
          setTimeout(check, 150);
        })();
      });
    }
    function installCartWatch() {
      if (cartWatch.installed) return;
      cartWatch.installed = true;
      try {
        var origFetch = window.fetch;
        if (typeof origFetch === 'function') {
          cartWatch.rawFetch = origFetch;
          window.fetch = function (input, init) {
            var url = (input && typeof input === 'object' && 'url' in input) ? input.url : String(input == null ? '' : input);
            var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
            // This page's own write (see ourCartFetch): not counted, not held.
            if (cartWatch.selfCall) { cartWatch.selfCall = false; return origFetch.apply(this, arguments); }
            if (!isCartChange(url, method)) return origFetch.apply(this, arguments);
            var self = this, args = arguments;
            // Counted from the moment it arrives, held or not.
            var id = cartChangeStarted();
            function send() {
              var p;
              try { p = origFetch.apply(self, args); } catch (e) { cartChangeEnded(id); throw e; }
              Promise.resolve(p).then(function () { cartChangeEnded(id); }, function () { cartChangeEnded(id); });
              return p;
            }
            if (!cartWatch.ours) return send();
            // One of this page's cart writes is out: send this one right after it.
            var waitOurs = cartWatch.ours;
            return new Promise(function (resolve) {
              var done = false;
              var t = setTimeout(go, 4000);
              waitOurs.then(go, go);
              function go() { if (done) return; done = true; clearTimeout(t); resolve(); }
            }).then(send);
          };
        }
      } catch (e) { /* noop */ }
      try {
        var XO = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
        if (XO && XO.open && XO.send) {
          var origOpen = XO.open, origSend = XO.send;
          XO.open = function (method, url) {
            // Re-opened before it ended: the earlier one no longer counts.
            if (this.__wshFysCartId) { cartChangeEnded(this.__wshFysCartId); this.__wshFysCartId = 0; }
            try { this.__wshFysCart = isCartChange(url == null ? '' : String(url), method); } catch (e) { this.__wshFysCart = false; }
            return origOpen.apply(this, arguments);
          };
          XO.send = function () {
            if (this.__wshFysCart) {
              var xhr = this;
              var id = cartChangeStarted();
              xhr.__wshFysCartId = id;
              var end = function () { if (xhr.__wshFysCartId === id) xhr.__wshFysCartId = 0; cartChangeEnded(id); };
              try { xhr.addEventListener('loadend', end); } catch (e) { /* noop */ }
              try { return origSend.apply(this, arguments); } catch (e2) { end(); throw e2; }
            }
            return origSend.apply(this, arguments);
          };
        }
      } catch (e) { /* noop */ }
    }
    installCartWatch();

    var markTimer = null, markBusy = false, markAgain = false;
    var removalBusy = 0;          // a leftover removal (with its own attribute write) is out
    var markWriteP = null;        // the marking write that is out, if any
    var markFailures = 0;         // a failed write is tried again (3 s apart, at most 3 times)
    function scheduleMark(delay) {
      if (markTimer) clearTimeout(markTimer);
      markTimer = setTimeout(doMark, delay == null ? 300 : delay);
    }
    function doMark() {
      markTimer = null;
      if (markBusy) { markAgain = true; return; }
      // A press is out: the claim link may be about to open (it sets the same
      // values itself). Try again later.
      var f = formEl();
      if (f && f.hasAttribute('data-wsh-claim-waiting')) { scheduleMark(1500); return; }
      // One cart write at a time from this page: wait for an add from BUNDLE
      // ALL THREE or a leftover removal to finish.
      var addOut = false; try { addOut = byoAddOnItsWay(); } catch (e) { addOut = false; }
      if (addOut || removalBusy > 0 || !cartQuiet()) { scheduleMark(1000); return; }
      if (!markingAttrs()) return;
      markBusy = true;
      var deferLater = false;
      var released = false;
      function release() {
        if (released) return; released = true;
        markBusy = false;
        if (markAgain) { markAgain = false; scheduleMark(); }
      }
      var safety = setTimeout(release, 10000);   // a write that never answers stops holding the queue
      var retryLater = false;
      var opts = { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
      var readP = fetch('/cart.js', opts).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
      withLimit(readP, CLAIM_TIMEOUT_MS, null).then(function (cart) {
        if (!cart) return null;
        var want = markingAttrs();          // read again: the cards may have changed meanwhile
        if (!want || !attrsDiffer(cart.attributes, want)) return null;
        // A press, an add or a removal started during the read: not now.
        var f2 = formEl(), addOut2 = false;
        try { addOut2 = byoAddOnItsWay(); } catch (e) { addOut2 = false; }
        if ((f2 && f2.hasAttribute('data-wsh-claim-waiting')) || addOut2 || removalBusy > 0 || !cartQuiet()) { deferLater = true; return null; }
        // The queue stays held until this write has really ended (it is never cancelled).
        var wp = ourCartFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: want }) })
          .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); markFailures = 0; return true; });
        markWriteP = wp.then(function () {}, function () {});
        markWriteP.then(function () { if (markWriteP && !markBusy) markWriteP = null; });
        return wp;
      }).then(function () { /* done */ }, function (err) {
        try { console.warn('[FYS] cart not marked:', err); } catch (e) { /* noop */ }
        if (markFailures < 3) { markFailures++; retryLater = true; }
      }).then(function () {
        clearTimeout(safety);
        if (deferLater && !markAgain) { setTimeout(function () { scheduleMark(0); }, 1000); }
        else if (retryLater && !markAgain) { setTimeout(function () { scheduleMark(0); }, 3000); }
        release();
      });
    }
    function removeLeftoverSampler(maxWaitMs) {
      var waitMs = maxWaitMs || 8000;
      // The counter drops only when the removal's own write has really ended
      // (or after 10 s), so a marking write never runs alongside it.
      removalBusy++;
      var settled = false, settle;
      var cap = setTimeout(function () { done(true); }, 10000);
      function done(failed) {
        if (settled) return; settled = true;
        clearTimeout(cap);
        removalBusy = Math.max(0, removalBusy - 1);
        if (failed) scheduleMark();   // its attribute write may not have landed
      }
      settle = done;
      // A marking write that is out finishes first, and no other cart change is
      // out (at most 8 s in all).
      return withLimit(markWriteP || Promise.resolve(), waitMs, null).then(function () {
        return waitCartQuiet(waitMs);
      }).then(function () {
        return removeLeftoverSamplerInner(settle);
      });
    }
    function removeLeftoverSamplerInner(settle) {
      settle = settle || function () {};
      // The read may be cancelled when late; a change, once sent, is never
      // cancelled (only no longer waited for).
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var opts = { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
      if (ctrl) opts.signal = ctrl.signal;
      var readP = fetch('/cart.js', opts).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      });
      return withLimit(readP, CLAIM_TIMEOUT_MS, null).then(function (cart) {
        if (!cart) { if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } } settle(false); return false; }
        var ids = samplerVariantIds();
        var updates = {}, any = false;
        ((cart && cart.items) || []).forEach(function (it) {
          if (!it || !it.key) return;
          if (it.handle === AUDITION_HANDLE || ids.indexOf(it.variant_id) >= 0) { updates[it.key] = 0; any = true; }
        });
        // Slice 2: the cart carries the run on screen. Whatever fys_ values a
        // leftover claim link left are replaced by this run's (never cleared:
        // a paid order that began here must carry them).
        var want = markingAttrs();
        var anyAttr = !!(want && attrsDiffer(cart && cart.attributes, want));
        if (!any && !anyAttr) { settle(false); return false; }
        var payload = {};
        if (any) payload.updates = updates;
        if (anyAttr) { payload.attributes = want; if (markTimer) { clearTimeout(markTimer); markTimer = null; } }
        var upP = ourCartFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
          .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json().catch(function () { return null; }); })
          .then(function (c) { lastItemCount = (c && typeof c.item_count === 'number') ? c.item_count : null; return any; });
        upP.then(function () { settle(false); }, function () { settle(anyAttr); });
        return withLimit(upP, CLAIM_TIMEOUT_MS, false);
      }).then(function (removed) {
        // removed: a Sampler line was taken out (the cart on screen should follow).
        return !!removed;
      }, function (err) {
        try { console.warn('[FYS] leftover Sampler not removed:', err); } catch (e) { /* noop */ }
        settle(false);
        return false;
      });
    }
    function announceCartChange() {
      try {
        var ev = new Event('cart:update', { bubbles: true });
        var d = { source: 'fys-claim' };
        if (lastItemCount !== null) d.itemCount = lastItemCount;
        ev.detail = { sourceId: 'fys-claim', data: d };
        document.dispatchEvent(ev);
      } catch (e) { /* noop */ }
    }
    /* Held box: before the visitor goes to their own checkout, a leftover
       Sampler comes out (it would be charged next to their libraries). */
    function clearLeftoverForHeld() {
      // The visitor is waiting on GO TO CHECKOUT: shorter waits (3 s each).
      return removeLeftoverSampler(3000).then(function (removed) { if (removed) announceCartChange(); return removed; });
    }

    /* The line under the button says what will happen. */
    function applyTail() {
      var t = tailEl(); if (!t) return;
      if (!t.hasAttribute('data-tail-default')) t.setAttribute('data-tail-default', t.textContent);
      var txt = (cartLibs && cartLibs > 0) ? t.getAttribute('data-tail-cart') : t.getAttribute('data-tail-default');
      if (txt && t.textContent !== txt) t.textContent = txt;
    }
    /* Read the cart again and bring the block up to date: the line under the
       button, and — once the cart no longer holds libraries — the form back in
       place of "Your sessions are saved". Not while a call is out. */
    function refreshCart() {
      var f = formEl(); if (!f) return;
      if (f.hasAttribute('data-wsh-claim-waiting')) return;
      var host = hostEl(); if (host && host.hidden) return;
      if (!resultsShowing()) return;
      var seqAtStart = callSeq;
      var readNo = cartReadSeq + 1;          // the number readCart is about to take
      readCart(CLAIM_TIMEOUT_MS).then(function (n) {
        if (cartOkSeq > readNo) return;      // a newer read has succeeded; it decided
        if (n === null) n = cartLibs;        // this read failed: the newest read that succeeded
        if (n === null) return;              // never known: leave the block as it is
        if (seqAtStart !== callSeq) return;  // a press started meanwhile; it reads the cart itself
        var f2 = formEl();
        if (!f2 || f2.hasAttribute('data-wsh-claim-waiting')) return;
        applyTail();
        // Follow-up (Phil, 8 Oct): back from their own checkout (a reload, the
        // Back button, another tab) with the cart still holding libraries and
        // the same answers within 30 minutes: "Your sessions are saved." again,
        // not the form.
        if (n > 0 && !isHeld()) {
          var al = alreadyEl();
          var h = heldForCurrent();
          if (h && !(al && !al.hidden)) {
            // Focus in the form (now hidden) moves to the box; otherwise it stays put.
            var fsx = fieldsEl();
            var inForm = !!(fsx && document.activeElement && fsx.contains(document.activeElement));
            setHeld(!!h.unsaved, { email: h.email || accountEmail(), quiet: !inForm });
          }
          return;
        }
        if (n === 0 && isHeld()) {
          var hb = heldEl();
          var hadFocus = !!(hb && document.activeElement && hb.contains(document.activeElement));
          setGuest();
          if (hadFocus) {
            var btn = submitEl();
            if (btn) { try { btn.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
          }
        }
      });
    }
    /* Saved for a return in another tab within the window: the answers (the
       same ticket wsh-fys.js already reads after a sign-in) and the run. */
    /* Follow-up (Phil, 8 Oct): the record also says how the box read
       (unsaved), who it was for, and the address, so the box can come back
       after a reload and GO TO CHECKOUT can fill the address in. */
    function saveHeldReturn(run, info) {
      info = info || {};
      try {
        var s = sessionStorage.getItem('wsh_fys_v1');
        if (s) localStorage.setItem('wsh_fys_return', JSON.stringify({ state_json: s, saved_at: Date.now() }));
      } catch (e) { /* noop */ }
      try {
        var row = readRow();
        if (row && row.id === run) localStorage.setItem('wsh_fys_held_run', JSON.stringify({
          id: row.id, fp: row.fp, seen: !!row.seen, at: row.at || 0, saved_at: Date.now(),
          unsaved: !!info.unsaved, who: info.who || '', email: info.email || ''
        }));
      } catch (e) { /* noop */ }
    }
    /* The held record for the run on screen, for whoever the block is for now. */
    function heldForCurrent() {
      var h = readHeldRun(); if (!h) return null;
      var row = readRow();
      if (!row || row.id !== h.id) return null;
      if (!h.who || h.who !== whoNow()) return null;
      return h;
    }
    /* GO TO CHECKOUT: the visitor's own checkout, with the address filled in
       when there is one. */
    function checkoutHref(email) {
      return email ? '/checkout?checkout%5Bemail%5D=' + encodeURIComponent(email) : '/checkout';
    }

    /* FYS-3B-1b — who the block is for.
       Signed in with a usable account email: that address, shown, not typed.
       Anyone else (guest, or an account with no usable email): the field. */
    function accountEmail() {
      if (!(owned && owned.signed_in)) return '';
      var c = validateEmail(owned.customer_email);
      return c.ok ? c.value : '';
    }
    function whoNow() {
      var acct = accountEmail();
      if (acct) return 'account:' + acct;
      return heldKx() ? 'link' : 'guest';   // slice 3: known only by the email link
    }
    function isSignedInNow() { return !!(owned && owned.signed_in); }
    /* Show the right pair: "Signed in as" + the address, or "Email" + the field. */
    function applyWho() {
      var acct = accountEmail();
      var signed = !!acct;
      // Slice 3: known by the email link: no field, a line in its place, and "Not you?".
      var link = !signed && !!heldKx();
      var lab = emailLabelEl(); if (lab) lab.hidden = signed || link;
      var inp = fieldEl();
      if (inp) {
        inp.hidden = signed || link;
        if (signed || link) inp.value = '';
      }
      var al = accountLabelEl(); if (al) al.hidden = !signed;
      var ab = accountEl();
      if (ab) {
        ab.textContent = signed ? acct : '';
        ab.hidden = !signed;
      }
      var ln = linkNoteEl(); if (ln) ln.hidden = !link;
      var ny = notYouEl(); if (ny) { ny.hidden = !link; ny.disabled = false; }
      // The press by link changes no consent, so the consent line is not shown.
      var cs = consentEl(); if (cs) cs.hidden = link;
      var btn = submitEl(); if (btn) btn.setAttribute('aria-describedby', link ? 'fys-claim-link-note' : 'fys-claim-account');
    }

    /* State setters (A4/A5/A6/A7). */
    function setGuest() {
      var f = formEl(); if (!f) return;
      if (checkoutSettleTimer) { clearTimeout(checkoutSettleTimer); checkoutSettleTimer = null; }
      f.removeAttribute('data-wsh-claim-waiting');
      var a = alreadyEl(); if (a) a.hidden = true;
      var hb = heldEl(); if (hb) hb.hidden = true;
      var fs = fieldsEl(); if (fs) fs.hidden = false;
      var el = fieldEl();
      if (el) {
        el.disabled = false;
        el.removeAttribute('aria-invalid');
      }
      var btn = submitEl();
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = 'SEND MY SESSIONS';
      }
      clearError();
      applyWho();
      applyTail();
    }
    function setWaiting() {
      var f = formEl(); if (!f) return;
      f.setAttribute('data-wsh-claim-waiting', '');
      var el = fieldEl();
      if (el) {
        try { el.blur(); } catch (e) { /* noop */ }
        el.disabled = true;
      }
      var btn = submitEl();
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'ONE MOMENT\u2026';
      }
      var ny = notYouEl(); if (ny) ny.disabled = true;
    }
    function setAlready() {
      var f = formEl(); if (!f) return;
      f.removeAttribute('data-wsh-claim-waiting');
      var fs = fieldsEl(); if (fs) fs.hidden = true;
      var hb = heldEl(); if (hb) hb.hidden = true;
      var a = alreadyEl();
      if (a) {
        a.hidden = false;
        var h = alreadyTitleEl();
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { try { h.focus(); } catch (e2) { /* noop */ } } }
      }
    }
    /* Cart slice — "Your sessions are saved." in place of the form, with the
       button to the visitor's own checkout. */
    /* opts.email: filled into GO TO CHECKOUT. opts.quiet: the box comes back on
       its own (reload, return), so focus is left where it is. */
    function setHeld(unsaved, opts) {
      opts = opts || {};
      var f = formEl(); if (!f) return;
      if (checkoutSettleTimer) { clearTimeout(checkoutSettleTimer); checkoutSettleTimer = null; }
      f.removeAttribute('data-wsh-claim-waiting');
      var fs = fieldsEl(); if (fs) fs.hidden = true;
      var a = alreadyEl(); if (a) a.hidden = true;
      var el = fieldEl(); if (el) el.disabled = false;
      var btn = submitEl();
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'SEND MY SESSIONS'; }
      var hb = heldEl();
      if (hb) {
        // The server did not get the call (failed or timed out): nothing was
        // saved, so the box says so in other words.
        var tEl = heldTitleEl(), bEl = hb.querySelector('[data-wsh-claim-held-body]');
        [[tEl, 'title'], [bEl, 'body']].forEach(function (p) {
          var el = p[0]; if (!el) return;
          if (!el.hasAttribute('data-held-saved')) el.setAttribute('data-held-saved', el.textContent);
          var txt = unsaved ? el.getAttribute('data-held-unsaved') : el.getAttribute('data-held-saved');
          if (txt) el.textContent = txt;
        });
        var cta = hb.querySelector('[data-wsh-claim-held-cta]');
        if (cta) cta.setAttribute('href', checkoutHref(opts.email || ''));
        hb.hidden = false;
        var h = heldTitleEl();
        if (h && !opts.quiet) { try { h.focus({ preventScroll: true }); } catch (e) { try { h.focus(); } catch (e2) { /* noop */ } } }
      }
    }
    function showError(text) {
      var err = errorEl(); if (!err) return;
      err.textContent = text;
      err.hidden = false;
      var el = fieldEl();
      if (el) {
        el.setAttribute('aria-invalid', 'true');
        try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) { /* noop */ } }
      }
    }
    function clearError() {
      var err = errorEl();
      if (err) { err.textContent = ''; err.hidden = true; }
      var el = fieldEl();
      if (el) el.removeAttribute('aria-invalid');
    }

    /* A5 — exact validation rules spelled out in the brief. */
    function validateEmail(raw) {
      var trimmed = String(raw == null ? '' : raw).replace(/^\s+|\s+$/g, '');
      if (trimmed === '') return { ok: false, msg: 'Enter your email address to get your sessions.', value: '' };
      // "one `@` with text before it and a dot with text on both sides after it, or it contains a space"
      if (/\s/.test(trimmed)) return { ok: false, msg: 'Check your email address. It should look like you@example.com.', value: trimmed };
      var at = trimmed.indexOf('@');
      if (at < 1 || at !== trimmed.lastIndexOf('@')) {
        return { ok: false, msg: 'Check your email address. It should look like you@example.com.', value: trimmed };
      }
      var local = trimmed.slice(0, at);
      var domain = trimmed.slice(at + 1);
      if (local.length < 1) return { ok: false, msg: 'Check your email address. It should look like you@example.com.', value: trimmed };
      var dot = domain.indexOf('.');
      if (dot < 1 || dot === domain.length - 1) {
        return { ok: false, msg: 'Check your email address. It should look like you@example.com.', value: trimmed };
      }
      return { ok: true, msg: '', value: trimmed };
    }

    /* Build the body sent to the claim server (§2). Fields with no valid
       value are omitted entirely (per §2). */
    function buildBody(email) {
      var s = currentState() || {};
      var run = ensureRun().id;
      var entry = readEntry();
      var samp = claimSetFor(s);
      var variant = samp && samp.variant_id;
      var body = {
        email: email,
        run: run,
        entry: entry,
        variant: variant,
        signed_in: !!(owned && owned.signed_in),
        hp: (trapEl() && trapEl().value) || ''
      };
      var g = fysGenreForServer(fysGenreLabel(s.genre) || s.genre); if (g) body.genre = g;
      var f = fysFormatForServer(s.format); if (f) body.format = f;
      var d = fysDawForServer(s.daw); if (d) body.daw = d;
      var c = fysCreatingForServer(s.use); if (c) body.creating = c;
      /* FYS-4H item 1 (2026-10-17): entry-tag sidecar. First-sticky in
         sessionStorage.wsh_fys_src (set by wsh-fys.js's ?src= first-touch;
         lower-case + [a-z0-9_-] + 24-char cap). Omitted when empty — the
         server treats '' as absent silently (never fys_src_rejected). */
      var src = '';
      try { src = sessionStorage.getItem('wsh_fys_src') || ''; } catch (e) { src = ''; }
      if (src) body.src = src;
      var pick = (s.pick && s.pick.library_handle) || '';
      if (pick) body.pick = pick;

      // §2: match / next / wildcard = the three handles AS SHOWN WHEN THE
      // BUTTON IS PRESSED. Read from scoreResult + ui at submit time.
      var m = scoreResult && scoreResult.match && scoreResult.match.handle;
      if (m) body.match = m;
      var nOpts = scoreResult && scoreResult.next && scoreResult.next.options;
      var wOpts = scoreResult && scoreResult.wildcard && scoreResult.wildcard.options;
      if (nOpts && nOpts.length) {
        var nIdx = ui.nIdx || 0;
        var nShown = nOpts[nIdx] || nOpts[0];
        if (nShown && nShown.handle) body.next = nShown.handle;
      }
      if (wOpts && wOpts.length) {
        var wIdx = ui.wIdx || 0;
        var wShown = wOpts[wIdx] || wOpts[0];
        if (wShown && wShown.handle) body.wildcard = wShown.handle;
      }
      // §2 alts — the OTHER options in each card's list, in order.
      body.alts = {
        match: [],
        next: nOpts ? nOpts.filter(function (o, i) { return i !== (ui.nIdx || 0); }).map(function (o) { return o.handle; }) : [],
        wildcard: wOpts ? wOpts.filter(function (o, i) { return i !== (ui.wIdx || 0); }).map(function (o) { return o.handle; }) : []
      };
      var note = (s.note || '').slice(0, 500);
      // A cut through an emoji leaves half a character, which cannot go in a link.
      if (/[\uD800-\uDBFF]$/.test(note)) note = note.slice(0, -1);
      if (note) body.note = note;
      return body;
    }

    /* B5 — build the checkout URL with explicit percent-encoding on every
       key and every value. Fields with no value are omitted. */
    function buildCheckoutUrl(email, body, variantId, atSec) {
      var code = (root.getAttribute('data-fys-claim-code') || 'WSHAUDITION').replace(/^\s+|\s+$/g, '');
      var origin = window.location.origin;
      var parts = [];
      function add(k, v) {
        if (v == null || v === '') return;
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v)));
      }
      add('discount', code);
      add('checkout[email]', email);
      add('attributes[fys_run]', body.run);
      add('attributes[fys_entry]', body.entry);
      add('attributes[fys_at]', String(atSec));
      add('attributes[fys_genre]', body.genre);
      add('attributes[fys_format]', body.format);
      add('attributes[fys_daw]', body.daw);
      add('attributes[fys_creating]', body.creating);
      add('attributes[fys_pick]', body.pick);
      add('attributes[fys_match]', body.match);
      add('attributes[fys_next]', body.next);
      add('attributes[fys_wildcard]', body.wildcard);
      add('attributes[fys_note]', body.note);
      // FYS-4H item 1 (2026-10-17) — entry-tag sidecar on the claim link.
      add('attributes[fys_src]', body.src);
      return origin + '/cart/' + variantId + ':1?' + parts.join('&');
    }

    /* Tracker — gated behind window.__wshFys.fysTrack. */
    function emit(name, props) {
      try {
        if (window.__wshFys && typeof window.__wshFys.fysTrack === 'function') {
          window.__wshFys.fysTrack(name, props || {});
        }
      } catch (e) { /* noop */ }
    }

    function trackFormatName(s) {
      if (!s) s = currentState();
      return fysFormatForServer(s.format) || 'Full Band';
    }

    /* §C.1 — fys:claim:seen · half of the block is in view, once per run.
       Called every renderClaim; replaces its observer so the current
       claim host is being observed. */
    var seenIO = null;
    function primeSeenObserver() {
      try { if (seenIO) seenIO.disconnect(); } catch (e) { /* noop */ }
      seenIO = null;
      if (typeof IntersectionObserver !== 'function') return;
      var host = root && root.querySelector('[data-wsh-claim]');
      if (!host || host.hidden) return;
      if (ensureRun().seen) return;
      seenIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (e.intersectionRatio >= 0.5) {
            var row = ensureRun();
            if (!row.seen) {
              row.seen = true;
              writeRow(row);
              emit('fys:claim:seen', { run: row.id, format: trackFormatName(), signed_in: isSignedInNow() });
            }
            try { seenIO.disconnect(); } catch (err) { /* noop */ }
            seenIO = null;
            return;
          }
        }
      }, { threshold: 0.5 });
      try { seenIO.observe(host); } catch (e) { /* noop */ }
    }

    /* B4 — the fetch. One request, AbortController for 2.5s, no retry. */
    function sendCall(email, body) {
      waitingRunId = body.run;
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      waitingAbort = ctrl;
      var timedOut = false;
      var timer = setTimeout(function () {
        timedOut = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } }
      }, CLAIM_TIMEOUT_MS);
      var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' };
      if (ctrl) opts.signal = ctrl.signal;
      return fetch(CLAIM_SERVER_URL, opts).then(function (res) {
        if (res.status !== 200) {
          clearTimeout(timer);
          return { kind: 'checkout', why: 'failed' };
        }
        return res.text().then(function (txt) {
          clearTimeout(timer);
          var parsed = null;
          try { parsed = JSON.parse(txt); } catch (e) { parsed = null; }
          if (parsed && parsed.claimed === true) return { kind: 'already' };
          if (parsed && parsed.claimed === false) return { kind: 'checkout', why: 'not_claimed' };
          // claimed:null, claimed absent, or body not JSON
          return { kind: 'checkout', why: 'unknown' };
        }, function () {
          clearTimeout(timer);
          if (timedOut) return { kind: 'checkout', why: 'timeout' };
          if (ctrl && ctrl.signal && ctrl.signal.aborted) return { kind: 'aborted' };
          return { kind: 'checkout', why: 'unknown' };
        });
      }, function () {
        clearTimeout(timer);
        if (timedOut) return { kind: 'checkout', why: 'timeout' };
        // Cancelled (run change, leaving the results, pageshow): the caller ignores it.
        if (ctrl && ctrl.signal && ctrl.signal.aborted && !timedOut) return { kind: 'aborted' };
        return { kind: 'checkout', why: 'failed' };
      });
    }

    /* B5 — stop sound + navigate the current tab to the checkout URL. */
    function openCheckout(email, body, variantId, atSec) {
      try { if (window.__wshFys && window.__wshFys.pauseAudio) window.__wshFys.pauseAudio(); } catch (e) { /* noop */ }
      try { if (window.__wshFys && window.__wshFys.closeSoundbar) window.__wshFys.closeSoundbar(); } catch (e) { /* noop */ }
      var url = buildCheckoutUrl(email, body, variantId, atSec);
      // Last line of B5: if the page is still showing 10 s after location was
      // set, return the block to the guest state.
      if (checkoutSettleTimer) clearTimeout(checkoutSettleTimer);
      checkoutSettleTimer = setTimeout(function () { setGuest(); }, CHECKOUT_SETTLE_MS);
      window.location.assign(url);
    }

    function resultsShowing() {
      return document.body.classList.contains('wsh-fys-screen--results');
    }

    /* ── Slice 3: the two email-link routes ─────────────────────────────── */
    /* The body for link-run / link-claim: the same run, answers and cards as
       the claim-start body, with the token in place of an address. No email
       field is ever sent. */
    function linkBody(kx, forClaim) {
      var b = buildBody('');
      var out = { kx: kx, run: b.run, entry: b.entry, hp: b.hp, alts: b.alts };
      // FYS-4H item 1 (2026-10-17) — 'src' added to the link-run / link-claim
      // body forwarder. Omitted when buildBody didn't set it (empty sticky).
      ['genre', 'format', 'daw', 'creating', 'pick', 'match', 'next', 'wildcard', 'note', 'src'].forEach(function (k) {
        if (b[k]) out[k] = b[k];
      });
      if (forClaim) { out.variant = b.variant; out.signed_in = isSignedInNow(); }
      return out;
    }
    /* One POST with a time limit. Resolves { status, json } or { failed:true,
       timeout, aborted }. Never rejects. */
    function postLink(url, body, timeoutMs, ctrl) {
      var timedOut = false;
      var timer = setTimeout(function () {
        timedOut = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } }
      }, timeoutMs);
      var opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit' };
      if (ctrl) opts.signal = ctrl.signal;
      return fetch(url, opts).then(function (res) {
        return res.text().then(function (txt) {
          clearTimeout(timer);
          var parsed = null;
          try { parsed = JSON.parse(txt); } catch (e) { parsed = null; }
          return { status: res.status, json: parsed };
        });
      }).then(null, function () {
        clearTimeout(timer);
        return { failed: true, timeout: timedOut, aborted: !!(ctrl && ctrl.signal && ctrl.signal.aborted && !timedOut) };
      });
    }
    /* The claim link from link-claim is opened only when it is the store's own
       cart link for the variant asked for. */
    function safeClaimUrl(u, variantId) {
      var x;
      try { x = new URL(String(u || '')); } catch (e) { return null; }
      if (x.protocol !== 'https:') return null;
      var host = x.hostname.toLowerCase();
      if (host !== String(window.location.hostname).toLowerCase() && !/(^|\.)wesoundhuman\.com$/.test(host)) return null;
      if (x.pathname !== '/cart/' + variantId + ':1') return null;
      return x.href;
    }

    /* link-run — once per run, after the results have shown for a few seconds. */
    var linkSaveTimer = null, linkSaveRun = null, linkSaveBusy = null;
    function scheduleLinkSave() {
      if (!linkMode() || !resultsShowing()) return;
      var row = ensureRun();
      if (!row || !row.id || row.linkSaved) return;
      if (linkSaveTimer && linkSaveRun === row.id) return;
      if (linkSaveBusy === row.id) return;
      if (linkSaveTimer) clearTimeout(linkSaveTimer);
      linkSaveRun = row.id;
      linkSaveTimer = setTimeout(function () { linkSaveTimer = null; doLinkSave(row.id, 0); }, LINK_SAVE_DELAY_MS);
    }
    function doLinkSave(runId, attempt) {
      if (!linkMode() || !resultsShowing()) return;
      var kx = heldKx();
      var row = readRow();
      if (!kx || !row || row.id !== runId || row.linkSaved) return;
      // A press is out: it saves the run itself. Look again once it has answered.
      var fw = formEl();
      if (fw && fw.hasAttribute('data-wsh-claim-waiting')) {
        if (linkSaveTimer) clearTimeout(linkSaveTimer);
        linkSaveRun = runId;
        linkSaveTimer = setTimeout(function () { linkSaveTimer = null; doLinkSave(runId, attempt); }, LINK_SAVE_WAIT_MS);
        return;
      }
      // One save out at a time for a run.
      if (linkSaveBusy === runId) return;
      var body = linkBody(kx, false);
      // The server saves only a complete run: genre, format and a card.
      if (!body.genre || !body.format || !(body.match || body.next || body.wildcard)) return;
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      linkSaveBusy = runId;
      postLink(LINK_RUN_URL, body, CLAIM_TIMEOUT_MS, ctrl).then(function (res) {
        if (linkSaveBusy === runId) linkSaveBusy = null;
        var r2 = readRow();
        var same = !!(r2 && r2.id === runId);
        if (!res.failed && res.status === 200 && res.json && res.json.ok === true) {
          if (same) { r2.linkSaved = true; writeRow(r2); }
          emit('fys:link:saved', { run: runId, format: trackFormatName() });
          return;
        }
        if (res.failed) {
          // A network failure or no answer in time: one more try.
          if (attempt < 1 && same) setTimeout(function () { doLinkSave(runId, attempt + 1); }, LINK_SAVE_RETRY_MS);
          return;
        }
        // The server refused it (off, rate limit, a check): not tried again for this run.
        if (same) { r2.linkSaved = 'refused'; writeRow(r2); }
      });
    }

    /* link-claim — answers, as the page reads them:
         known + claimed true                  → already
         known + claimed false/null + link     → link (the claim link)
         anything else (known false, variant_ok false, an error, no answer
         in time, a link that is not ours)     → field (type an address) */
    function sendLinkClaim(body) {
      waitingRunId = body.run;
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      waitingAbort = ctrl;
      return postLink(LINK_CLAIM_URL, body, CLAIM_TIMEOUT_MS, ctrl).then(function (res) {
        if (res.failed) {
          if (res.aborted) return { kind: 'aborted' };
          return { kind: 'field', why: res.timeout ? 'timeout' : 'failed' };
        }
        var j = res.json;
        if (res.status !== 200 || !j || j.ok !== true) return { kind: 'field', why: 'failed' };
        if (j.known !== true) return { kind: 'field', why: 'unknown' };
        if (j.claimed === true) return { kind: 'already' };
        if (j.variant_ok === false) return { kind: 'field', why: 'variant' };
        var url = safeClaimUrl(j.claim_url, body.variant);
        if ((j.claimed === false || j.claimed === null) && url) return { kind: 'link', url: url, why: j.claimed === false ? 'not_claimed' : 'unknown' };
        return { kind: 'field', why: 'bad_answer' };
      });
    }
    /* The press by link. Same guards, cart rule and events as the typed press;
       the claim link comes from the server. */
    function onLinkSubmit() {
      var kx = heldKx();
      var who = whoNow();
      var signedIn = isSignedInNow();
      var body = linkBody(kx, true);
      if (!(typeof body.variant === 'number' && body.variant > 0)) return;
      setWaiting();
      emit('fys:claim:press', { run: body.run, format: trackFormatName(), signed_in: signedIn, via: 'link' });
      var mySeq = ++callSeq;
      var cartP = readCart(CLAIM_TIMEOUT_MS);
      function stillWanted() {
        if (mySeq !== callSeq) return false;
        var f3 = formEl(), row3 = readRow(), host3 = hostEl();
        return !!(f3 && f3.hasAttribute('data-wsh-claim-waiting')) && resultsShowing() && !!(row3 && row3.id === body.run)
          && !(host3 && host3.hidden) && whoNow() === who;
      }
      function markSaved() {
        var r = readRow();
        if (r && r.id === body.run && r.linkSaved !== true) { r.linkSaved = true; writeRow(r); }
        if (linkSaveTimer && linkSaveRun === body.run) { clearTimeout(linkSaveTimer); linkSaveTimer = null; }
      }
      sendLinkClaim(body).then(function (res) {
        if (mySeq !== callSeq) return;
        waitingAbort = null;
        waitingRunId = null;
        if (!stillWanted() || (res && res.kind === 'aborted')) {
          var f2 = formEl();
          if (f2 && f2.hasAttribute('data-wsh-claim-waiting')) setGuest();
          return;
        }
        if (res.kind === 'field') {
          // Nothing to type was not possible this time: the usual field.
          dropKx();
          setGuest();
          lastWho = whoNow();
          showError('Enter your email address and we’ll send your sessions.');
          emit('fys:claim:fallback', { run: body.run, format: trackFormatName(), signed_in: signedIn, why: res.why });
          return;
        }
        // The server has the run (link-claim saves it).
        markSaved();
        if (res.kind === 'already') {
          clearHeldRun(true);
          setAlready();
          emit('fys:claim:already', { run: body.run, format: trackFormatName(), signed_in: signedIn, via: 'link' });
          return;
        }
        function dropIfUnwanted() {
          if (stillWanted()) return false;
          var f4 = formEl();
          if (mySeq === callSeq && f4 && f4.hasAttribute('data-wsh-claim-waiting')) setGuest();
          return true;
        }
        function holdsLibraries(n) {
          if (byoAddOnItsWay()) return true;
          if (n !== null) return n > 0;
          return cartLibs !== null && cartLibs > 0;
        }
        function hold() {
          // Pay first, sessions after. The server has the press; the reminder follows.
          setHeld(false, { email: '' });
          applyTail();
          saveHeldReturn(body.run, { unsaved: false, who: who, email: '' });
          clearLeftoverForHeld();
          emit('fys:claim:held', { run: body.run, format: trackFormatName(), signed_in: signedIn, why: res.why, via: 'link' });
        }
        cartP.then(function (libs1) {
          if (dropIfUnwanted()) return;
          if (holdsLibraries(libs1)) { hold(); return; }
          readCart(1500).then(function (libs2) {
            if (dropIfUnwanted()) return;
            if (holdsLibraries(libs2)) { hold(); return; }
            clearHeldRun(true);
            emit('fys:claim:checkout', { run: body.run, format: trackFormatName(), signed_in: signedIn, why: res.why, via: 'link' });
            try { if (window.__wshFys && window.__wshFys.pauseAudio) window.__wshFys.pauseAudio(); } catch (e) { /* noop */ }
            try { if (window.__wshFys && window.__wshFys.closeSoundbar) window.__wshFys.closeSoundbar(); } catch (e) { /* noop */ }
            if (checkoutSettleTimer) clearTimeout(checkoutSettleTimer);
            checkoutSettleTimer = setTimeout(function () { setGuest(); }, CHECKOUT_SETTLE_MS);
            window.location.assign(res.url);
          });
        });
      });
    }
    /* "Not you? Use another email": the token is set aside for this visit and
       the usual field comes back, focused. */
    function onNotYou(e) {
      if (e && e.preventDefault) e.preventDefault();
      var f = formEl();
      if (f && f.hasAttribute('data-wsh-claim-waiting')) return;
      if (!heldKx()) return;
      var row = readRow();
      dropKx();
      setGuest();
      lastWho = whoNow();
      var el = fieldEl();
      if (el) { try { el.focus({ preventScroll: true }); } catch (err) { try { el.focus(); } catch (err2) { /* noop */ } } }
      emit('fys:link:not-you', { run: (row && row.id) || null, format: trackFormatName() });
    }
    /* Stop a call that is out and forget it. Its answer, if one still arrives, is ignored. */
    function cancelPending() {
      callSeq++;
      if (waitingAbort) { try { waitingAbort.abort(); } catch (e) { /* noop */ } }
      waitingAbort = null;
      waitingRunId = null;
      var f = formEl();
      if (f && f.hasAttribute('data-wsh-claim-waiting')) setGuest();
    }

    /* The submit handler itself. */
    function onSubmit(ev) {
      if (ev && ev.preventDefault) ev.preventDefault();
      var f = formEl(); if (!f) return;
      // Second submit while waiting: do nothing, send nothing (brief A7).
      if (f.hasAttribute('data-wsh-claim-waiting')) return;
      // The block is hidden (already claimed, or no listing): nothing to send.
      var host = hostEl();
      if (host && host.hidden) return;
      // Cart slice hardening: the block belongs to the results screen. A submit
      // from anywhere else (the form is in the page but not on screen) sends nothing.
      if (!resultsShowing()) return;
      // Clear any prior validation state before re-validating.
      clearError();
      // FYS-3B-1b: signed in, the address is the account's. Nothing is typed,
      // so there is nothing to check and no error line.
      var email = accountEmail();
      // Slice 3: known by the email link: the press goes to link-claim.
      if (!email && linkMode()) { onLinkSubmit(); return; }
      if (!email) {
        var raw = fieldEl() ? fieldEl().value : '';
        var check = validateEmail(raw);
        if (!check.ok) {
          showError(check.msg);
          return;
        }
        email = check.value;
      }
      var who = whoNow();
      var signedIn = isSignedInNow();
      var body = buildBody(email);
      // Guard: hide-when-variant-invalid is already applied at render time,
      // but defend here too. (No call fires when samp.variant_id is bad.)
      if (!(typeof body.variant === 'number' && body.variant > 0)) return;
      setWaiting();
      var atSec = runAt();   // slice 2: the run's time, the same value the cart marking carries
      emit('fys:claim:press', { run: body.run, format: trackFormatName(), signed_in: signedIn });
      var mySeq = ++callSeq;
      // Cart slice: read the cart at the same time as the call, within the same 2.5 s.
      var cartP = readCart(CLAIM_TIMEOUT_MS);
      function stillWanted() {
        if (mySeq !== callSeq) return false;
        var f3 = formEl(), row3 = readRow(), host3 = hostEl();
        return !!(f3 && f3.hasAttribute('data-wsh-claim-waiting')) && resultsShowing() && !!(row3 && row3.id === body.run)
          && !(host3 && host3.hidden) && whoNow() === who;
      }
      sendCall(email, body).then(function (res) {
        // Cancelled or replaced by a newer call: nothing to do.
        if (mySeq !== callSeq) return;
        waitingAbort = null;
        waitingRunId = null;
        var f2 = formEl();
        var row2 = readRow();
        var host2 = hostEl();
        var wanted = !!(f2 && f2.hasAttribute('data-wsh-claim-waiting')) && resultsShowing() && !!(row2 && row2.id === body.run)
          && !(host2 && host2.hidden) && whoNow() === who;
        if (!wanted || (res && res.kind === 'aborted')) {
          // The visitor left the results screen, or the run changed, while the
          // call was out. No checkout, no message, no event.
          if (f2 && f2.hasAttribute('data-wsh-claim-waiting')) setGuest();
          return;
        }
        if (res && res.kind === 'already') {
          clearHeldRun(true);
          setAlready();
          emit('fys:claim:already', { run: body.run, format: trackFormatName(), signed_in: signedIn });
          return;
        }
        // Checkout branch — but not over a cart that holds libraries.
        function dropIfUnwanted() {
          if (stillWanted()) return false;
          var f4 = formEl();
          if (mySeq === callSeq && f4 && f4.hasAttribute('data-wsh-claim-waiting')) setGuest();
          return true;
        }
        // Holds libraries? A read that failed falls back to the last count the
        // page knew (null = never known, treated as empty).
        function holdsLibraries(n) {
          if (byoAddOnItsWay()) return true;
          if (n !== null) return n > 0;
          return cartLibs !== null && cartLibs > 0;
        }
        function hold() {
          // Pay first, sessions after. No checkout; the cart is not touched.
          var unsaved = res.why === 'failed' || res.why === 'timeout';
          setHeld(unsaved, { email: email });
          applyTail();
          // A signed-in visitor's address is not kept: the checkout knows them.
          saveHeldReturn(body.run, { unsaved: unsaved, who: who, email: who === 'guest' ? email : '' });
          clearLeftoverForHeld();
          emit('fys:claim:held', { run: body.run, format: trackFormatName(), signed_in: signedIn, why: res.why });
        }
        cartP.then(function (libs1) {
          if (dropIfUnwanted()) return;
          if (holdsLibraries(libs1)) { hold(); return; }
          // Read once more, now: a library may have been added while the
          // press was waiting.
          readCart(1500).then(function (libs2) {
            if (dropIfUnwanted()) return;
            if (holdsLibraries(libs2)) { hold(); return; }
            // An empty cart (or one never read): the claim link, as before.
            clearHeldRun(true);
            emit('fys:claim:checkout', { run: body.run, format: trackFormatName(), signed_in: signedIn, why: res.why });
            openCheckout(email, body, body.variant, atSec);
          });
        });
      });
    }

    function wire() {
      var f = formEl();
      if (!f) return;
      if (f.getAttribute('data-wsh-claim-wired') === '1') return;
      f.setAttribute('data-wsh-claim-wired', '1');
      // One `submit` listener on the form (brief A4). No click, no key listener.
      f.addEventListener('submit', onSubmit);
      // A5 — clear the error + outline as soon as the field's content changes.
      var el = fieldEl();
      if (el) {
        el.addEventListener('input', function () { clearError(); });
      }
      // Slice 3: "Not you? Use another email".
      var ny = notYouEl();
      if (ny) ny.addEventListener('click', onNotYou);
      // GO TO CHECKOUT: a leftover Sampler comes out before the visitor's own
      // checkout opens (usually well under a second; at most about 11 s when
      // other cart changes are out; the checkout opens either way).
      var cta = root && root.querySelector('[data-wsh-claim-held-cta]');
      if (cta) cta.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        var href = cta.getAttribute('href') || '/checkout';
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { clearLeftoverForHeld(); return; }
        e.preventDefault();
        if (cta.getAttribute('aria-busy') === 'true') return;
        cta.setAttribute('aria-busy', 'true');
        var label = cta.textContent;
        cta.textContent = 'ONE MOMENT\u2026';
        clearLeftoverForHeld().then(function () {
          cta.removeAttribute('aria-busy');
          cta.textContent = label;
          window.location.assign(href);
        });
      });
      // A middle click (new tab) fires auxclick, not click.
      if (cta) cta.addEventListener('auxclick', function (e) { if (e.button === 1) clearLeftoverForHeld(); });
    }

    /* Called by renderClaim on every hydrate. */
    function reconcileForRun(variantId) {
      // B2: a run id is made only while the results screen is the one showing.
      if (!resultsShowing()) return;
      var fp = fpOfState(currentState());
      var existing = readRow();
      var current;
      if (existing && existing.fp === fp && existing.id && !rebuildWants(existing, fp)) {
        current = existing;
      } else {
        current = newRow(fp);
        writeRow(current);
      }
      var f = formEl();
      if (!f) return;
      wire();
      var who = whoNow();
      if ((lastRenderedRunId && lastRenderedRunId !== current.id) || (lastWho !== null && lastWho !== who)) {
        // B7 — the run id changed, or (1b) the block is now for someone else:
        // signed in, signed out, or a different account. Abort anything in
        // flight; back to the resting state for whoever it is now.
        cancelPending();
        setGuest();
      } else if (!lastRenderedRunId) {
        // First render this page life: ensure the resting state unless a prior
        // tab-return left us in waiting (BFCache preserved DOM state).
        if (!f.hasAttribute('data-wsh-claim-waiting')) setGuest();
      }
      lastRenderedRunId = current.id;
      lastWho = who;
      primeSeenObserver();
      applyTail();
      refreshCart();
      scheduleLinkSave();   // slice 3: known by the email link, the run is saved
    }

    /* 1b — the block has just been hidden because the visitor has claimed.
       Stop a call that is out; its answer must not open a checkout. */
    function onHidden() {
      cancelPending();
      try { if (seenIO) seenIO.disconnect(); } catch (e) { /* noop */ }
      seenIO = null;
    }

    /* B6 — the page has come back from the browser's back-forward cache (the
       visitor returned from the checkout we opened): if the block is still
       waiting, return it to rest.
       Only then. A page's first pageshow follows its load event, and a press
       made before the page had finished loading must not be cancelled by it. */
    function onPageShow(ev) {
      if (!ev || ev.persisted !== true) return;
      var f = formEl();
      if (!f) return;
      if (f.hasAttribute('data-wsh-claim-waiting')) cancelPending();
    }
    window.addEventListener('pageshow', onPageShow);
    /* Cart slice — coming back. Whenever the page is shown again, the tab comes
       back into view, or the cart changes on this page, read the cart again.
       Once it holds no libraries (they have paid), the form returns. */
    /* Slice 2: the same moments re-check the cart's marking (a new cart after
       paying, another tab's run), whether or not the claim block is shown. */
    function remarkIfShowing() { if (resultsShowing()) scheduleMark(); }
    window.addEventListener('pageshow', function () { refreshCart(); remarkIfShowing(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { refreshCart(); remarkIfShowing(); }
    });
    window.addEventListener('focus', function () {
      if (Date.now() - cartReadAt > 1000) refreshCart();
      remarkIfShowing();
    });
    document.addEventListener('cart:update', function () { refreshCart(); remarkIfShowing(); });

    /* Leaving the results. Capture phase, so this runs before wsh-fys.js
       changes the state.
       Start again: remember the entry (state.from is about to be cleared),
       stop any call that is out, and end the run.
       Edit answers, Try another genre, Find another sound, Exit, Sign in:
       stop any call that is out. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== 'function') return;
      var a = t.closest('[data-wsh-fys-restart]');
      if (a) { readEntry(); cancelPending(); clearRow(); clearHeldRun(); return; }
      if (t.closest('.wsh-fys-results__edit-link, [data-wsh-try-another], [data-wsh-find-another], [data-wsh-fys-exit], [data-wsh-fys-signin]')) cancelPending();
    }, true);

    /* The form is wired as soon as the script runs, not at the first render,
       so a press before the page data arrives can never submit the form the
       browser's own way (which would put the address in the page address). */
    readHeldRun();   // an expired record (address included) goes as soon as the page runs
    captureKx();     // slice 3: the email-link token, kept for this visit
    stripKxWhenKlaviyoHasIt();
    wire();
    /* Slice 3 fix 1: the claim block reads right from the start, not only once
       the page data has arrived (a reminder link opens straight on the
       results, and the field must not show for a visitor known by the link). */
    // A signed-in visitor (the server says so in the page) waits for the account.
    if (!(root && root.getAttribute('data-customer-signed-in') === 'true')) applyWho();

    return {
      rebuildActive: rebuildActive,
      reconcileForRun: reconcileForRun,
      onHidden: onHidden,
      refreshCart: refreshCart,
      removeLeftoverSampler: removeLeftoverSampler,
      announceCartChange: announceCartChange,
      ourCartFetch: ourCartFetch,
      waitCartQuiet: waitCartQuiet,
      scheduleMark: scheduleMark,
      getRun: function () { return ensureRun().id; },
      _clearRow: clearRow
    };
  })();

  /* Public: later slices need the run id for cart-attribute reads. */
  window.__wshFysResults = window.__wshFysResults || {};
  window.__wshFysResults.getRun = function () {
    try { return __fysClaim.getRun(); } catch (e) { return null; }
  };
})();

/* =============================================================================
 * FYS-P3 round 4 (2026-10-16): mobile sticky role-tab strip helpers.
 * ADDITIVE append. No existing listener or variable is removed or modified.
 *
 *   - Scroll-to-card on tab tap at ≤749px. CSS scroll-margin-top on
 *     .wsh-fys-card lands the card below the sticky strip.
 *   - Stuck-state hairline via IntersectionObserver on the sentinel
 *     that sits just above the tabs in flow.
 *
 * The pre-existing tab click handler (this file, line 1304) runs FIRST
 * — it switches the active card via applyTab(). The appended click
 * listener below runs AFTER (registration order) and scrolls the newly
 * active card into view. A swipe keeps the strip's selected tab in step
 * via the existing swipe handler at line 1465 (unchanged).
 * ============================================================================= */
(function () {
  var MOBILE_MQL = typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 749px)')
    : { matches: false };
  var tabs = document.querySelector('[data-wsh-tabs]');
  var cards = document.querySelector('[data-wsh-cards]');
  if (!tabs || !cards) return;

  // Scroll-to-card on tap. Delegate from document so re-renders don't matter.
  document.addEventListener('click', function (e) {
    if (!MOBILE_MQL.matches) return;
    var tab = e.target && e.target.closest ? e.target.closest('[data-wsh-tab]') : null;
    if (!tab || !document.contains(tab)) return;
    var role = tab.getAttribute('data-wsh-tab');
    if (!role) return;
    // Wait one frame so the existing handler's applyTab() has switched
    // the active card BEFORE we scroll.
    requestAnimationFrame(function () {
      var target = cards.querySelector('[data-wsh-card="' + role + '"]');
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }, false);

  // Fix v2 (2026-10-16): a swipe STARTED ON THE STRIP must not change the
  // active card. The pre-existing swipe handler at this file's line 1468
  // listens on the cards container for touchstart/touchmove/touchend; now
  // that the strip lives inside that container, raw touches on the strip
  // would bubble to that handler. Stop touch-event propagation at the
  // strip (passive, so no preventDefault — vertical scroll stays free).
  // Click events are synthesised separately after touchend and still
  // reach the tab buttons' click handlers.
  var touchStop = function (e) { e.stopPropagation(); };
  var passive = { passive: true };
  tabs.addEventListener('touchstart', touchStop, passive);
  tabs.addEventListener('touchmove',  touchStop, passive);
  tabs.addEventListener('touchend',   touchStop, passive);

  // Stuck-state hairline. The sentinel is a zero-height marker just above
  // the tabs in flow. IO's root is the viewport; rootMargin pulls the top
  // edge down by top-bar height, so intersecting the (shrunken) root
  // means "below the top bar" and NOT intersecting means "above/behind
  // the top bar" i.e. the sticky tabs are stuck.
  var sentinel = document.querySelector('[data-wsh-tabs-sentinel]');
  if (sentinel && typeof window.IntersectionObserver === 'function') {
    var cs = window.getComputedStyle(document.body);
    var raw = (cs.getPropertyValue('--fys-topbar-h') || '').trim();
    var topbarH = parseInt(raw, 10);
    if (!topbarH || isNaN(topbarH)) topbarH = 56;
    var io = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        tabs.classList.toggle('is-stuck', !entries[i].isIntersecting);
      }
    }, {
      threshold: 0,
      rootMargin: '-' + (topbarH + 1) + 'px 0px 0px 0px',
    });
    io.observe(sentinel);
  }
})();
